import React, { useEffect, useState, useCallback, useRef } from "react";
import NavTabs from "../../../components/nav-tabs/index";
import Input from "../../../components/input/index";
import CommomButton from "../../../components/common-button/index";
import StatusChip from "../../../components/status-chip/index";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import { ReactImageCarouselViewer } from "react-image-carousel-viewer";
import {
  Table,
  Toast,
  Card,
  ToastContainer,
  Image as Img,
  OverlayTrigger,
  Modal,
  Tooltip as TT,
  Button,
  Dropdown,
} from "react-bootstrap";
import {
  fetchCampaignDetail,
  // updateGuestStatus,
  fetchAllCampaignDetail,
  fetchCampaignById,
  cloneCampaign,
  deleteCampaign,
  cancelCampaign,
  fetchAllCampaigns,
  clearCampaignContacts,
  deductCreditForDraftedCampaign,
  resendSingleRecipientCampaign,
  fetchManualSettlement,
  switchCampaignToManual,
} from "../../../store/eventsSlice";
import { Container, Col, Row } from "react-bootstrap";
import "../../pages/eventsDetails/styleModule.css";
import { useNavigate, useParams } from "react-router-dom";
import CommonLayout from "../../layouts/master/index";
import { useLoader } from "../../../context/LoaderContext";
import moment from "moment";
import * as XLSX from "xlsx";
import axios from "axios";
import { pdfjs, Document, Page } from "react-pdf";
import {
  Calendar03Icon,
  SentIcon,
  UserIcon,
  MessageSearch01Icon,
  MessageDone01Icon,
  MessagePreview01Icon,
  MessageCancel01Icon,
  Message01Icon,
  MessageQuestionIcon,
  ReloadIcon,
  ArrowLeftIcon,
  CheckmarkBadge04Icon,
  Cancel01Icon,
  FileDownloadIcon,
  Delete02Icon,
  Coins01Icon,
  UserGroup03Icon,
  MessageDelay01Icon,
  Coins02Icon,
  Copy02Icon,
  MessagePreview02Icon,
  ArrowDown01Icon,
  MessageEdit01Icon,
  CancelCircleIcon,
  InvalidIcon,
  FailedIcon,
  CoinsSwapIcon,
  RefreshIcon,
  ExportIcon,
  ResendIcon,
  RestartIcon,
  PauseCircleIcon,
  DownloadAllIcon,
  // PlayIcon,
  // PauseIcon,
} from "../../../icons/icons";
import { CampaignsDataTabs } from "../../../constants/pages/campaign/detail/index";
import CommonPagination from "../../../components/common-pagination";
import Zoom from "react-medium-image-zoom"; // For image zooming
import "react-medium-image-zoom/dist/styles.css"; // Image zooming styles
// import PdfZoomViewModal from "./PdfZoomViewModal";
import JSZip from "jszip";
import { downloadZip } from "client-zip";
import { saveAs } from "file-saver";
import { PDFDocument, rgb } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import CreatableSelect from "react-select/creatable";
import { recordsPerPageOptions } from "../campaings/common/Common";
import TableLoader from "../../../components/TableLoader";
import DeletePopup from "../../../components/delete-popup";
import Checkbox from "../../../components/checkbox";
import SmallWidgets from "../../../components/winget/small-wingets";
import { DownloadIcon } from "../../../constants/icons/icons";
import useDisableBackButton from "../../../hooks/useDisableBrowserBackBtn";
import BackPageBtnTab from "../../../components/back-page-btn-tab";
import PdfViewer from "./PdfViewer";
import { removePagesByIndex } from "../../../utils/pdfUtils";
import { userDetails } from "../../../store/authSlice";
import ConfirmationModal from "../../../components/modals/ConfirmationModal";
import axiosapi from "../../../utilities/axiosApi";

let ws;

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function CampaignDetails() {
  // Use the hook to disable the browser back button
  useDisableBackButton();

  const [isOpen, setIsOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { setLoading, loading } = useLoader();
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("toast-success");
  const user = useSelector((state)=> state.auth.user);
  const [isDownloadAllLoading, setIsDownloadAllLoading] = useState(false);
  const [zipProgress, setZipProgress] = useState(null);

  // const total = useSelector((state) => state.events?.total);
  const [total, setTotal] = useState(0);
  // const totalPages = useSelector((state) => state.events?.totalPages);
  // const campaingDetails = useSelector((state) => state.events?.campaingDetails);
  const [campaignDetails, setCampaignDetails] = useState([]);
  const [campaignDetailListWithoutRedux, setCampaignDetailListWithoutRedux] =
    useState([]);    
  // const campaignDetailLoader = useSelector((state) => state.events?.loader);

  const [latestGuestList, setLatestGuestList] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState({ value: 10, label: 10 });
  const [searchTerm, setSearchTerm] = useState("");
  const [documentUrl, setDocumentUrl] = useState(null);
  // const [pdfTotalPages, setPdfTotalPages] = useState(0);
  const [pdfCurrentPage, setPdfCurrentPage] = useState(1);
  // console.log("pdfCurrentPage",pdfCurrentPage);

  // const [activeTab, setActiveTab] = useState("list");
  // const [isFailedSelected, setIsFailedSelected] = useState(false);
  // const [isInvalidSelected, setIsInvalidSelected] = useState(false);
  const [activeSubTab, setActiveSubTab] = useState("guests");

  const [activeTabStatus, setActiveTabStatus] = useState("all");
  const [tableLoading, setTableLoading] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [deleteCampaignModal, setDeleteCampaignModal] = useState(false);

  const [selectedItems, setSelectedItems] = useState([]);

  const [openCancelCampaign, setOpenCancelCampaign] = useState(false);
  const [resendLoadingId, setResendLoadingId] = useState(null); // store recipient ID during resend

  // Data passed from Customer Details
  let customerDetailLimit = location?.state?.limit || { value: 10, label: 10 };
  let customerDetailPageNo = location?.state?.currentPage || 0;
  // console.log("customerDetailLimit===>",customerDetailLimit)
  // console.log("customerDetailPageNo==>",customerDetailPageNo)

  // Retrieve from sessionStorage (if available)

  const [showCreditModal, setShowCreditModal] = useState(false);
  // Handing a stalled campaign to helpers. The settlement is read from the API
  // before the confirmation opens, because the refund is not the same as the
  // worklist: guests that failed permanently were refunded when they failed.
  const [showManualModal, setShowManualModal] = useState(false);
  const [manualSettlement, setManualSettlement] = useState(null);
  const [isManualBusy, setIsManualBusy] = useState(false);
  const [pendingDownloadItem, setPendingDownloadItem] = useState(null);
  const [pendingMultipleDownloadItems, setPendingMultipleDownloadItems] = useState([]);
  const [downloadMode, setDownloadMode] = useState("single");
  // const [isCampaignPaused, setIsCampaignPaused] = useState(false);
  const [pendingMultipleDeductionCount, setPendingMultipleDeductionCount] = useState(0);


  const currentPagePassedInDetail = location?.state?.currentPage || 0;

  const currentCampaignPagePassedLimit = location?.state?.limit || {
    value: 10,
    label: 10,
  };
  const isFirstLoad = useRef(true);

  // console.log("currentCampaignPagePassedLimit :: ",currentCampaignPagePassedLimit);

  // console.log("campaignDetailList :: ",campaignDetailList);

  // Store in sessionStorage when data is received


  const fetchDocument = useCallback(
    async (url) => {
      try {
        setLoading(true);
        const response = await axios.get(url, { responseType: "blob" });
        // console.log("response : ",response);
        const blobUrl = URL.createObjectURL(response.data);
        // console.log("blobUrl : ",blobUrl);

        setDocumentUrl(blobUrl);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching document: ", error);
        setLoading(false);
      }
    },
    [setLoading]
  );

  const fetchNewCampaignDetailData = useCallback(() => {
      
      // setIsFailedSelected(false);
      // setIsInvalidSelected(false);
      setTableLoading(true);

      const fetchParams = {
        offset: currentPage,
        limit: limit?.value,
        is_test: activeSubTab === "guests" ? "false" : "true",
        id: id,
      };


      if (activeTabStatus !== "all") {
        fetchParams.status = activeTabStatus;
      }

      dispatch(
        fetchCampaignDetail(fetchParams)
      )
        .then((res) => {
          if (res?.payload?.campaingDetailsData?.data) {
            console.log("update-new");
            setCampaignDetailListWithoutRedux(res?.payload?.campaingDetailsData);
            setTotal(res.payload.campaingDetailsData.total);
          }
        })
        .catch(() => {
          setTableLoading(false);
        })
        .finally(() => {
          setLoading(false);
          setTableLoading(false);
        });
    }, [
      dispatch,
      currentPage,
      limit?.value,
      id,
      activeSubTab,
      setLoading,
      activeTabStatus,
      // activeTab,
    ]);

  // MAIN API Handler
    const fetchCampaignDetailData = useCallback(() => {
      // if (activeTab === "list") {
      // window.scrollTo({ top: 0, behavior: "smooth" });
      // setIsFailedSelected(false);
      // setIsInvalidSelected(false);
      // setLoading(true);
      // console.log("Main API...");
      setTableLoading(true);

      const fetchParams = {
        offset: currentPage,
        limit: limit?.value,
        is_test: activeSubTab === "guests" ? "false" : "true",
        id: id,
      };


      if (activeTabStatus !== "all") {
        fetchParams.status = activeTabStatus;
      }

      dispatch(
        fetchCampaignDetail(
          // {// offset: currentPage,
          // limit: limit?.value,
          // is_test: activeSubTab === "guests" ? "false" : "true",
          // id: id,}
          fetchParams
        )
      )
        .then((res) => {
          if (res?.payload?.campaingDetailsData?.data) {
            console.log("update-1");
            setCampaignDetailListWithoutRedux(res?.payload?.campaingDetailsData);
            setTotal(res.payload.campaingDetailsData.total);
          }
        })
        .catch(() => {
          setTableLoading(false);
        })
        .finally(() => {
          setLoading(false);
          setTableLoading(false);
        });

        const fetchParams1 = {
          // offset: currentPage,
          // limit: limit?.value,
          is_test: "false",
          id: id,
        };

      dispatch(
        fetchCampaignDetail(
        // {// offset: currentPage,
        // limit: limit?.value,
        // is_test: activeSubTab === "guests" ? "false" : "true",
        // id: id,}
          fetchParams1
        )
      )
        .then((res) => {
          if (res?.payload?.campaingDetailsData?.data) {
            console.log("update-2");
              setLatestGuestList(res?.payload?.campaingDetailsData);
          }
        })
        .catch(() => {
          setTableLoading(false);
        })
        .finally(() => {
          setLoading(false);
          setTableLoading(false);
        });
    }, [
      dispatch,
      currentPage,
      limit?.value,
      id,
      activeSubTab,
      setLoading,
      activeTabStatus,
      // activeTab,
    ]);

  // API Call for search
  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }

    if (searchTerm.trim() === "") {
      // 🚨 If search is cleared, reset to full listing
      fetchCampaignDetailData();
      return;
    }

    const fetchParams = {
      search: searchTerm,
      offset: currentPage,
      limit: limit?.value,
      is_test: false,
      id: id,
    };

    if (activeTabStatus !== "all") {
      fetchParams.status = activeTabStatus;
    }

    const handler = setTimeout(() => {
      setTableLoading(true);
      dispatch(fetchCampaignDetail(fetchParams))
        .then((res) => {
          if (res?.payload?.campaingDetailsData?.data) {
            console.log("update-3");
            setCampaignDetailListWithoutRedux(
              res?.payload?.campaingDetailsData
            );
            setTotal(res.payload.campaingDetailsData.total);
          } else {
            console.log("update-4");
            setCampaignDetailListWithoutRedux([]);
          }
        })
        .catch(() => {
          console.log("update-5");
          setCampaignDetailListWithoutRedux([]);
        })
        .finally(() => {
          setTableLoading(false);
        });
    }, 500);

    return () => {
      clearTimeout(handler); // Clear timeout if searchTerm changes
    };
  }, [
    dispatch,
    fetchCampaignDetailData,
    id,
    searchTerm,
    currentPage,
    limit?.value,
    activeTabStatus,
  ]);

const fetchCampaignByIdData = useCallback(
  async (withLoader = false) => {
    try {
      if (withLoader) setLoading(true);

      const response = await dispatch(fetchCampaignById({ id })).unwrap();

      const { campaingDetails } = response;
      setCampaignDetails(campaingDetails);

      if (campaingDetails?.new_template_url) {
        fetchDocument(campaingDetails.new_template_url);
      }
    } finally {
      if (withLoader) setLoading(false);
    }
  },
  [dispatch, id, setLoading, fetchDocument]
);


  useEffect(() => {
    fetchCampaignDetailData();
  }, [fetchCampaignDetailData]);

  useEffect(() => {
    fetchCampaignByIdData();
  }, [fetchCampaignByIdData]);

  const handleStatusClick = (status) => {
    setCurrentPage(0);
    setActiveTabStatus(status);
  };

  // useEffect(() => {
  //   setIsInvalidSelected(activeTabStatus === "invalid");
  //   setIsFailedSelected(activeTabStatus === "failed");
  // }, [activeTabStatus]);

  const handleRefreshClick = useCallback(() => {
    setTableLoading(true);

    const fetchParams = {
      offset: currentPage,
      limit: limit?.value,
      is_test: activeSubTab === "guests" ? "false" : "true",
      id: id,
    };

    if (activeTabStatus !== "all") {
      fetchParams.status = activeTabStatus;
    }

    dispatch(fetchCampaignDetail(fetchParams))
      .then((res) => {
        if (res?.payload?.campaingDetailsData?.data) {
          console.log("update-6");
          setCampaignDetailListWithoutRedux(res?.payload?.campaingDetailsData);
          setTotal(res.payload.campaingDetailsData.total);
        }
      })
      .finally(() => {
        setTableLoading(false);
      });

    const fetchParams1 = {
      // offset: currentPage,
      // limit: limit?.value,
      is_test: "false",
      id: id,
    };

    dispatch(fetchCampaignDetail(fetchParams1))
      .then((res) => {
        if (res?.payload?.campaingDetailsData?.data) {
          console.log("update-7");
          setLatestGuestList(res?.payload?.campaingDetailsData);
        }
      })
      .finally(() => {
        setTableLoading(false);
      });
  }, [dispatch, currentPage, limit?.value, activeSubTab, id, activeTabStatus]);
  

  useEffect(() => {
    // let ws;

    ws = new WebSocket(process.env.REACT_APP_SOCKET_URL);

    ws.onopen = () => {
      const wsId = `cmd_${id}`;
      ws.send(JSON.stringify({ type: "REGISTER", id: wsId }));
      // setSock(ws);
    };

  //  let reloadTimeout;

  ws.onmessage = (event) => {
    const data = JSON.parse(event.data);
    console.log("DATA", data);
    const { guest, status, reason } = data;    
    
    // if (guest?.id) {
    //   console.log("🔄 Reload table for guest:", guest.id);

    //   clearTimeout(reloadTimeout);
    //   reloadTimeout = setTimeout(() => {
    //     fetchCampaignDetailData();
    //   }, 1000);
    // }

      if (!guest?.id) return;
      fetchCampaignByIdData();    

      const disconnectReasons = [
        "Whatsapp Disconnected",
        "Whatsapp Disconnected...!",
        "WhatsApp session disconnected",
      ];

      if (status === "failed" && disconnectReasons.some(r => (reason || "").includes(r))) {
        fetchCampaignByIdData();
      }

      setCampaignDetailListWithoutRedux((prev) => {
        if (!prev || !Array.isArray(prev.data)) return prev;

        const updatedData = prev.data.map((item) =>
          item.id === guest.id
            ? {
                ...item,
                status,
                whatsapp_sent: data.whatsapp_sent ?? item.whatsapp_sent,
                whatsapp_deliver: data.whatsapp_deliver ?? item.whatsapp_deliver,
                whatsapp_seen: data.whatsapp_seen ?? item.whatsapp_seen,
                failed_reason: data.reason ?? item.failed_reason,
              }
            : item
        );

        return { ...prev, data: updatedData };
      });

    
      // setCampaignDetailListWithoutRedux((prev) => {
      //   console.log("update-8", prev);
      //   if (!prev || !Array.isArray(prev.data)) return prev;
    
      //   // Find the previous status of the guest
      //   const previousGuest = prev.data.find(item => item.id === guest.id);
      //   const previousStatus = previousGuest?.status || 'pending';
    
      //   const updatedData = prev.data.map((item) => {
      //     if (item.id === guest.id) {
      //       return {
      //         ...item,
      //         status,
      //         // failed_reason: reason || item.failed_reason,
      //         // whatsapp_sent: whatsapp_sent ?? item.whatsapp_sent,
      //         // whatsapp_deliver: whatsapp_deliver ?? item.whatsapp_deliver,
      //         // whatsapp_seen: whatsapp_seen ?? item.whatsapp_seen,
      //       };
      //     }
      //     return item;
      //   });
    
      //   // Update the stats based on status change
      //   let updatedStats = { ...prev };
        
      //   // Decrease count for previous status
      //   if (previousStatus === 'pending' && updatedStats.total_pending > 0) {
      //     updatedStats.total_pending--;
      //   } else if (previousStatus === 'sent' && updatedStats.total_sent > 0) {
      //     updatedStats.total_sent--;
      //   } else if (previousStatus === 'delivered' && updatedStats.total_delivered > 0) {
      //     updatedStats.total_delivered--;
      //   } else if ((previousStatus === 'seen' || previousStatus === 'read') && updatedStats.total_seen > 0) {
      //     updatedStats.total_seen--;
      //   } else if (previousStatus === 'failed' && updatedStats.total_failed > 0) {
      //     updatedStats.total_failed--;
      //   } else if (previousStatus === 'invalid' && updatedStats.total_invalid > 0) {
      //     updatedStats.total_invalid--;
      //   } else if (previousStatus === 'not-seen' && updatedStats.total_not_seen > 0) {
      //     updatedStats.total_not_seen--;
      //   } else if (previousStatus === 'cancelled' && updatedStats.total_cancelled > 0) {
      //     updatedStats.total_cancelled--;
      //   }
        
      //   // Increase count for new status
      //   if (status === 'pending') {
      //     updatedStats.total_pending = (updatedStats.total_pending || 0) + 1;
      //   } else if (status === 'sent') {
      //     updatedStats.total_sent = (updatedStats.total_sent || 0) + 1;
      //   } else if (status === 'delivered') {
      //     updatedStats.total_delivered = (updatedStats.total_delivered || 0) + 1;
      //   } else if (status === 'seen' || status === 'read') {
      //     updatedStats.total_seen = (updatedStats.total_seen || 0) + 1;
      //   } else if (status === 'failed') {
      //     updatedStats.total_failed = (updatedStats.total_failed || 0) + 1;
      //   } else if (status === 'invalid') {
      //     updatedStats.total_invalid = (updatedStats.total_invalid || 0) + 1;
      //   } else if (status === 'not-seen') {
      //     updatedStats.total_not_seen = (updatedStats.total_not_seen || 0) + 1;
      //   } else if (status === 'cancelled') {
      //     updatedStats.total_cancelled = (updatedStats.total_cancelled || 0) + 1;
      //   }
    
      //   return { ...updatedStats, data: updatedData };
      // });

      // if (activeTabStatus === "all" && activeSubTab === "guests") {
        // console.log("IN-ACTIVE-TAB-2", activeTabStatus);
        setLatestGuestList((prev) => {
          if (!prev || !Array.isArray(prev.data)) return prev;
      
          // Find the previous status of the guest
          const previousGuest = prev.data.find(item => item.id === guest.id);
          const previousStatus = previousGuest?.status || 'pending';
      
          const updatedData = prev.data.map((item) => {
            if (item.id === guest.id) {
              return {
                ...item,
                status,
                // failed_reason: reason || item.failed_reason,
                // whatsapp_sent: whatsapp_sent ?? item.whatsapp_sent,
                // whatsapp_deliver: whatsapp_deliver ?? item.whatsapp_deliver,
                // whatsapp_seen: whatsapp_seen ?? item.whatsapp_seen,
              };
            }
            return item;
          });
      
          // Update the stats based on status change
          let updatedStats = { ...prev };
          
          // Decrease count for previous status
          if (previousStatus === 'pending' && updatedStats.total_pending > 0) {
            updatedStats.total_pending--;
          } else if (previousStatus === 'sent' && updatedStats.total_sent > 0) {
            updatedStats.total_sent--;
          } else if (previousStatus === 'delivered' && updatedStats.total_delivered > 0) {
            updatedStats.total_delivered--;
          } else if ((previousStatus === 'seen' || previousStatus === 'read') && updatedStats.total_seen > 0) {
            updatedStats.total_seen--;
          } else if (previousStatus === 'failed' && updatedStats.total_failed > 0) {
            updatedStats.total_failed--;
          } else if (previousStatus === 'invalid' && updatedStats.total_invalid > 0) {
            updatedStats.total_invalid--;
          } else if (previousStatus === 'not-seen' && updatedStats.total_not_seen > 0) {
            updatedStats.total_not_seen--;
          } else if (previousStatus === 'cancelled' && updatedStats.total_cancelled > 0) {
            updatedStats.total_cancelled--;
          }
          
          // Increase count for new status
          if (status === 'pending') {
            updatedStats.total_pending = (updatedStats.total_pending || 0) + 1;
          } else if (status === 'sent') {
            updatedStats.total_sent = (updatedStats.total_sent || 0) + 1;
          } else if (status === 'delivered') {
            updatedStats.total_delivered = (updatedStats.total_delivered || 0) + 1;
          } else if (status === 'seen' || status === 'read') {
            updatedStats.total_seen = (updatedStats.total_seen || 0) + 1;
          } else if (status === 'failed') {
            updatedStats.total_failed = (updatedStats.total_failed || 0) + 1;
          } else if (status === 'invalid') {
            updatedStats.total_invalid = (updatedStats.total_invalid || 0) + 1;
          } else if (status === 'not-seen') {
            updatedStats.total_not_seen = (updatedStats.total_not_seen || 0) + 1;
          } else if (status === 'cancelled') {
            updatedStats.total_cancelled = (updatedStats.total_cancelled || 0) + 1;
          }
      
          return { ...updatedStats, data: updatedData };
        });
      // }
      
      // Check if campaign is completed (no more pending messages)
      setCampaignDetails((prevDetails) => {
        console.log("update-9", prevDetails);

        if (!prevDetails) return prevDetails;
        
        const updatedDetails = { ...prevDetails };
        
        // Get current stats from campaignDetailListWithoutRedux
        setLatestGuestList((data) => {
          // console.log("Latest Guest List Updated:", data);
          setCampaignDetailListWithoutRedux((currentStats) => {
            console.log("Current Stats Updated:", currentStats);
            console.log("Prev Details Updated:", prevDetails);
            if (data?.total_pending === 0 && prevDetails.status === 'in-process') {
              console.log("update-10", prevDetails);
              // All messages processed, update campaign status
              updatedDetails.status = 'completed';
              updatedDetails.completed_at = new Date().toISOString();
              dispatch(userDetails());

              // fetchCampaignByIdData();
            }
            return currentStats;
          });
          return data; // keep state unchanged if you don't want to modify
        });
        
        return updatedDetails;
      });

      fetchNewCampaignDetailData();

      // dispatch(updateGuestStatus({ id: guest.id, status, reason }));
    
      // Only show snackbar for important status changes
      if (['sent', 'failed', 'invalid'].includes(status)) {
        setSnackbarMessage(`Message to ${guest.mobile_number} ${status}`);
        setSnackbarVariant(status === "sent" ? "toast-success" : "toast-danger");
        setShowSnackbar(true);
      }
    };

    ws.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    ws.onclose = () => {
      setTimeout(() => {
        ws = new WebSocket(process.env.REACT_APP_SOCKET_URL);
      }, 1000);
    };


    return () => {
      ws.close();
    };
  }, [dispatch, id, handleRefreshClick, fetchNewCampaignDetailData, fetchCampaignByIdData]);


  const handlePageChange = (newPageNumber) => {
    setCurrentPage(newPageNumber - 1);
    // window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // const handleBackClick = () => {
  //   const clientId = campaingDetailsData?.data[0]?.client_id;
  //   console.log("clientId ", clientId);

  //   if (clientId) {
  //     const targetPath = `/customers/${clientId}`;
  //     // console.log("Navigating to:", targetPath);
  //     navigate(targetPath, { replace: true });
  //     window.location.href = targetPath; // Fallback to ensure navigation
  //   } else {
  //     console.error("Client ID not found, unable to navigate.");
  //     navigate(-1); // Go back one step if clientId is not available
  //   }
  // };

  const handleBackClick = () => {
    const clientId =
      campaignDetailListWithoutRedux?.data?.[0]?.client_id ||
      campaignDetails?.client_id;

    // Get the current path
    const currentPath = location.pathname;

    // if (clientId) {
    //   const targetPath = `/customers/${clientId}`;
    //   // console.log("Navigating to:", targetPath);
    //   navigate(targetPath, { replace: true });
    //   window.location.href = targetPath; // Fallback to ensure navigation
    // } else {
    //   console.error("Client ID not found, unable to navigate.");
    //   navigate(-1); // Go back one step if clientId is not available
    // }
    if (currentPath.includes("/customers/view-campaign")) {
      sessionStorage.setItem("customerDetailPage", customerDetailPageNo);
      sessionStorage.setItem(
        "customerDetailLimit",
        JSON.stringify(customerDetailLimit)
      );
      navigate(`/customers/${clientId}`, {
        replace: true,
        state: { fromCampaignDetail: true },
      });
    } else if (currentPath.includes("/all-campaigns/view-campaign")) {
      sessionStorage.setItem("currentPageNo", currentPagePassedInDetail);
      sessionStorage.setItem(
        "currentPageLimit",
        JSON.stringify(currentCampaignPagePassedLimit)
      );
      navigate("/all-campaigns", { replace: true });
    } else {
      navigate(-1); // Go back one step if clientId is not available
    }
  };

  const handleExportClick = async () => {
    try {
      setLoading(true); // Enable loading state
      let requestData = {
        limit: campaignDetailListWithoutRedux?.total_recipients,
        is_test: "false",
        id: id,
      };

      if (activeTabStatus !== "all") {
        requestData.status = activeTabStatus;
      }

      const allDataResponse = await dispatch(
        fetchAllCampaignDetail(requestData)
      ).unwrap();

      const data = allDataResponse?.campaingDetailsData?.data;

      if (!data || !data.length) {
        console.warn("No data available to export");
        setLoading(false);
        return;
      }

      // Collect all unique variable keys across the dataset
      const allVariableKeys = Array.from(
        new Set(data.flatMap((event) => Object.keys(event.variables || {})))
      );

      // Map the data for export
      const dataToExport = data.map((event) => {
        const variables = event.variables || {};
        const variableColumns = allVariableKeys.reduce((acc, key) => {
          acc[key] = variables[key] || "-"; // Add variable value or leave empty
          return acc;
        }, {});

        return {
          Name: event?.name || "N/A",
          Number: event?.mobile_number || "N/A",
          ...variableColumns, // Add dynamic variable columns
          Date: event?.campaign?.created_at
            ? new Date(event.campaign.created_at).toLocaleString("en-IN", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })
            : "-",
          ScheduleDate: event?.campaign?.scheduler_date
            ? moment(event.campaign.scheduler_date).format("DD/MM/YYYY hh:mm A")
            : "-",
          Status: event?.status !== "pending" ? event.status : "Pending",
          FailedReason: event?.failed_reason || "-",
          CreditsUsed: event?.credits || 0,
          SentStatus: event?.whatsapp_sent
            ? new Date(event.whatsapp_sent * 1000).toLocaleString("en-IN", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })
            : "-",
          DeliveryStatus: event?.whatsapp_deliver
            ? new Date(event.whatsapp_deliver * 1000).toLocaleString("en-IN", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })
            : "-",
          SeenStatus: event?.whatsapp_seen
            ? new Date(event.whatsapp_seen * 1000).toLocaleString("en-IN", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              })
            : "-",
        };
      });

      // Export to Excel
      const worksheet = XLSX.utils.json_to_sheet(dataToExport);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Campaign Details");

      const fileName = `${campaignDetails?.client_event?.name || "Campaign"}_${
        campaignDetails?.name || "Details"
      }_${activeTabStatus}_${new Date().toISOString().split("T")[0]}.xlsx`;

      XLSX.writeFile(workbook, fileName);
      setLoading(false); // Disable loading state
    } catch (error) {
      console.error("Error exporting data: ", error);
      setLoading(false); // Disable loading state on error
    }
  };

  const handleRestartCampaignClick = async () => {
    try {
      // Only check connection for personal WhatsApp, not for official WhatsApp
      const isOfficialWhatsApp = campaignDetails?.sender_type === "official";

      if (!isOfficialWhatsApp && !campaignDetails?.client_event?.whatsapp_client?.is_active) {
        setSnackbarMessage("Please connect WhatsApp.");
        setSnackbarVariant("toast-danger");
        setShowSnackbar(true);
        return;
      }

      setLoading(true);

      const result = await await axiosapi.post(
        `/api/customer/restart-campaign/${id}`,
        {
          clientId: campaignDetailListWithoutRedux?.data[0]?.client_id,
          wsId: "cmd",
          campaignId: id,
          fileUrl:
            campaignDetailListWithoutRedux?.data[0]?.campaign?.template_type !==
            "text"
              ? `${campaignDetailListWithoutRedux?.data[0]?.campaign?.template_url}`
              : null,
          companyId: campaignDetailListWithoutRedux?.data[0]?.company_id,
        }
      );
      console.log("Restart RESUltttt", result);
      if(result.data.success){
        setSnackbarMessage("Campaign restarted successfully");
        setSnackbarVariant("toast-success");
        setShowSnackbar(true);
        fetchCampaignByIdData();
      }else{
        setSnackbarMessage("Failed to start campaign restart");
        setSnackbarVariant("toast-danger");
        setShowSnackbar(true);
      }
    } catch (error) {
      setSnackbarMessage("Failed to start campaign restart");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
    } finally {
      setLoading(false);
    }
  };


const handleResendFailedMessagesClick = async () => {

  try {
    // Only check connection for personal WhatsApp, not for official WhatsApp
    const isOfficialWhatsApp = campaignDetails?.sender_type === "official";

    if (!isOfficialWhatsApp && !campaignDetails?.client_event?.whatsapp_client?.is_active) {
      setSnackbarMessage("Please connect WhatsApp.");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
      return;
    }

    setLoading(true);

    const result = await axiosapi.post(
      `/api/customer/resend-message-to-failed-guests/${id}`,
      {
        clientId: campaignDetailListWithoutRedux?.data[0]?.client_id,
        wsId: "cmd",
        campaignId: id,
        fileUrl:
          campaignDetailListWithoutRedux?.data[0]?.campaign?.template_type !==
          "text"
            ? `${campaignDetailListWithoutRedux?.data[0]?.campaign?.template_url}`
            : null,
        companyId: campaignDetailListWithoutRedux?.data[0]?.company_id,
      }
    );

    if(result.data.success){
      setSnackbarMessage("Resending failed messages started successfully");
      setSnackbarVariant("toast-success");
      setShowSnackbar(true);
      fetchCampaignByIdData();
    }else{
      setSnackbarMessage("Failed to start resending messages");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
    }
  } catch (error) {
    setSnackbarMessage("Failed to start resending messages");
    setSnackbarVariant("toast-danger");
    setShowSnackbar(true);
  } finally {
    setLoading(false);
  }
};


  const handleInvalidClick = async () => {
    try {
      setLoading(true);
      dispatch(cloneCampaign({ id: id }))
        .then((response) => {
          // console.log("Response :::: ", response);
          if (response && response.payload && response.payload.success) {
            setSnackbarMessage("New Campaign Created Successfully!");
            setSnackbarVariant("toast-success");
            setShowSnackbar(true);
            // navigate(``)
            handleModalClose();
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      setSnackbarMessage("Failed to Create New Campaig");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    // setPdfTotalPages(numPages);
    setPdfCurrentPage(1);
    // setNumPages(numPages);
  };

  const handleSubTabSelect = (key) => {
    console.log("Selected SubTab:", key);
    
    setActiveSubTab(key);
    setCurrentPage(0);
    setSearchTerm("");
    dispatch(clearCampaignContacts());

    setTableLoading(true);
    // ✅ Add a delay before fetching new data
    // setTimeout(() => {
    //   setTableLoading(false);
    // }, 5000); // 5-second delay
  };

  const getUserInitial = (name) => {
    return name
      ? name
          .split(" ")
          .map((n) => n.charAt(0))
          .join("")
      : "UN";
  };

  const titles = [{ name: "Customers", path: "/customers" }];

  const [showAddModal, setShowAddModal] = useState(false);

  const handleModalClose = () => {
    setShowAddModal(false);
  };

  const handleOpenModal = () => {
    setShowAddModal(true);
  };

  // const [openPdfModalView, setOpenPdfModalView] = useState(false);
  const [pdfPageWiseView, setPdfPageWiseView] = useState([]);
  // console.log("pdfPageWiseView",pdfPageWiseView);

  // Handler for opening the Pdf Zoom View
  const handleOpenPdfView = async () => {
    setLoading(true);
    if (campaignDetails?.template_type === "pdf") {
      const url = campaignDetails?.new_template_url; // API-provided PDF URL
      // Convert PDF to page-wise images or load directly
      // console.log("url ::", url);

      let res = await processPdf(url);
      // console.log("res",res);

      // if (res.length > 0) {
      //   setPdfPageWiseView(res); // Set page-wise view
      // }

      if (res.length > 0) {
        setPdfPageWiseView(res); // ✅ Ensure images are set before opening
        setIsOpen(true); // ✅ Open the viewer only after setting images
      } else {
        console.error("No images generated from PDF");
      }
    }
    setLoading(false);
    // await new Promise(() =>
    //   setTimeout(() => {
    //     // setOpenPdfModalView(true);
    //     setLoading(false);
    //   }, 2000)
    // );
  };

  const processPdf = async (pdfUrl) => {
    // Example logic using react-pdf (or PDF.js for advanced splitting):
    const pdfjsLib = window.pdfjsLib;
    const pdfDoc = await pdfjsLib.getDocument(pdfUrl).promise;
    // const pdfDoc = await pdfjsLib.getDocument(`http://localhost:8000/storage/Campaigns/1728043874.pdf`).promise;

    // Extract each page as an image and store in pdfPageWiseView
    const pageImages = [];
    for (let i = 1; i <= pdfDoc.numPages; i++) {
      const page = await pdfDoc.getPage(i);
      const viewport = page.getViewport({ scale: 1 });
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      await page.render({ canvasContext: context, viewport }).promise;
      const base64Image = canvas.toDataURL("image/png");
      pageImages.push({
        base64: base64Image,
        width: viewport.width,
        height: viewport.height,
      });
    }
    // console.log("pageImages ::: ", pageImages);

    // let arr = pageImages.map((item) => {
    //   // console.log("Each item converting array :::: ", item);
    //   return { src: item.base64 };
    // });

    // console.log("final:arr : ", arr);
    let arr = pageImages.map((item) => ({
      original: item.base64, // Full-size image
      thumbnail: item.base64, // Thumbnail (Optional)
    }));
    // setPdfPageWiseView(arr);

    return arr;

    // if (pageImages.length > 0) {
    //   setPdfPageWiseView(arr); // Set page-wise view
    // }
  };

  // Handler for closing the Pdf Zoom View
  // const handleClosePdfViewModal = () => {
  //   setOpenPdfModalView(false);
  // };

  // Utility to check if the URL is an image
  const isImageFile = (url) => {
    const imageExtensions = [".jpeg", ".jpg", ".png"];
    return imageExtensions.some((ext) => url.toLowerCase().endsWith(ext));
  };

  // The template and its fonts are the same for every guest, so a bulk
  // download fetches each file once instead of once per guest.
  const fileBytesCache = useRef({});
  const fetchFileBytes = (url) => {
    if (!fileBytesCache.current[url]) {
      fileBytesCache.current[url] = fetch(url)
        .then((res) => res.arrayBuffer())
        .catch((err) => {
          delete fileBytesCache.current[url];
          throw err;
        });
    }
    return fileBytesCache.current[url];
  };

  const changeFont = async (data) => {
    let pos = campaignDetails?.variable_positions; // Get the positions of the text

    const existingPdfBytes = await fetchFileBytes(campaignDetails?.new_template_url);
    const pdfDocs1 = await PDFDocument.load(existingPdfBytes);
    const pages = pdfDocs1.getPages();
    pdfDocs1.registerFontkit(fontkit);
    
    let embeddedFonts = [];

    // Loop through positions and embed fonts dynamically based on `pos`
    for (let key in pos) {
      const fontObject = pos[key];

      const fontBytes = await fetchFileBytes(fontObject.fontFile);
      await fontkit.create(fontBytes);
      const embeddedFont = await pdfDocs1.embedFont(fontBytes, { subset: true });
      embeddedFonts.push(embeddedFont);
    }

    let index = 0;
    for (let key in pos) {
      const page = pages[pos[key].page - 1]; // Page to draw text on
      const { height } = page.getSize(); // Get the height of the page
      const textHeight = embeddedFonts[index].sizeAtHeight(pos[key]?.size); // Get text height based on font size
      let x = pos[key].x; // Default X coordinate

      // Determine the Y position based on the alignment
      let y = height - (pos[key].y + textHeight - (textHeight >= 46
        ? 7
        : textHeight >= 30
        ? 6
        : textHeight >= 12
        ? 3
        : 1)); // Adjust for the font height

      // Get text content from `data` or use placeholder
      const text = data[key]?.replaceAll(/;/g, ",") || "";

      // Apply alignment logic
      const textWidth = embeddedFonts[index].widthOfTextAtSize(text, pos[key].size); // Get text width

      if (pos[key].align === "center") {
        x = pos[key].x + (pos[key].width - textWidth) / 2; // Center alignment
      } else if (pos[key].align === "right") {
        x = pos[key].x + (pos[key].width - textWidth); // Right alignment
      }

      // Draw text on the PDF page with adjusted position and alignment
      page.drawText(text, {
        x: x,
        y: y,
        size: pos[key]?.size,
        font: embeddedFonts[index],
        color: rgb(pos[key]?.color[0] / 255, pos[key]?.color[1] / 255, pos[key]?.color[2] / 255),
      });

      index++;
    }

    const pdfBytes = await pdfDocs1.save();
    return pdfBytes; // Return the modified PDF
  };

  // Download Failed Campaigns (PDFs or Images)
  const downloadFailedZip = async (failedList, type) => {
    // console.log("failedList, type",failedList, type);
    if (!failedList || failedList.length === 0) {
      alert("No failed campaigns to download");
      return;
    }
    // setLoading(true);

    const zip = new JSZip();

    for (let i = 0; i < failedList.length; i++) {
      const entry = failedList[i];
      // console.log("entry", entry);

      const url = entry?.campaign?.template_url;
      // console.log("url :: :: ", url);

      if (url.endsWith(".pdf")) {
        // Process PDF
        try {
          const pdfBytes = await changeFont({
            ...entry?.variables,
            name: entry?.name,
          });

          const fileName = generateUniqueFileName(failedList, entry, "pdf");

          zip.file(fileName, pdfBytes);
        } catch (error) {
          console.error("Error processing PDF:", error);
        }
      } else if (isImageFile(url)) {
        //     // Process Image
        try {
          // Check if the entry contains an array of image URLs
          const imageUrls = Array.isArray(entry.imageUrls)
            ? entry.imageUrls
            : [url];

          // Get API base URL from environment variable
          // const apiUrl = process.env.REACT_APP_API_URL;

          // console.log("imageUrls", imageUrls);

          // Loop through each image URL
          for (let j = 0; j < imageUrls.length; j++) {
            const imageUrl = `${imageUrls[j]}`;
            // console.log("imageUrl", imageUrl);

            const imageResponse = await fetch(imageUrl);
            // console.log("imageResponse", imageResponse?.url);

            if (!imageResponse.ok) {
              console.error(`Failed to fetch image from URL: ${imageUrl}`);
              continue; // Skip this image and proceed to the next
            }

            const imageBlob = await imageResponse.blob();
            // console.log("imageBlob", imageBlob);

            const fileExtension = url.split(".").pop();
            const fileName = generateUniqueFileName(failedList, entry, fileExtension, imageUrls.length > 1 ? j : null);
            // console.log("fileName", fileName);

            zip.file(fileName, imageBlob);
          }
        } catch (error) {
          console.error("Error processing image:", error);
        }
      } else {
        console.warn(`Unsupported file type for entry: ${entry.name}`);
      }
    }

    // Generate the ZIP file and download it
    try {
      const content = await zip.generateAsync({ type: "blob" });
      saveAs(
        content,
        type === "failed" ? "failed-list.zip" : "invalid-list.zip"
      );
      setLoading(false);
    } catch (error) {
      console.error("Error generating ZIP:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const showBtnIfArrHasPdfOrImg =
    Array.isArray(campaignDetailListWithoutRedux?.data) &&
    campaignDetailListWithoutRedux.data.length > 0 &&
    campaignDetailListWithoutRedux.data.some(
      (item) =>
        item.campaign?.template_type === "pdf" ||
        item.campaign?.template_type === "image"
    );

  const handleChange = (newValue) => {
    if (newValue) {
      // Update state with both value and label
      setLimit({ value: newValue.value, label: newValue.label });
      setCurrentPage(0);
    } else {
      // If the value is null (when user clears selection), set a default value
      setLimit({ value: 10, label: 10 }); // Set to default object
      setCurrentPage(0);
    }
  };

  // console.log("campaingDetailsData :: Table", campaingDetailsData);
  // console.log("campaingDetailsOBJ : : ", campaingDetails);

  // Open Delete Campaign Modal
  const handleDeleteCampaign = () => {
    setDeleteCampaignModal(true);
  };

  // Final handler of Delete Campaign
  const handleConfirmDeleteCampaign = () => {
    try {
      setIsSubmitting(true); // Set loading state
      setLoading(true); // Optional loader if you have one
      dispatch(deleteCampaign({ id: id }));
      setSnackbarMessage("Campaign deleted successfully");
      setSnackbarVariant("toast-success");
      setShowSnackbar(true);
      navigate("/all-campaigns");
    } catch (error) {
      setSnackbarMessage("Failed to delete campaign");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
      setLoading(false);
    } finally {
      setIsSubmitting(false);
      setLoading(false); // Optional loader
      setDeleteCampaignModal(false);
    }
  };

    const hideDownloadCampaign = ["scheduled", "drafted"];
  const hideDownloadColumn = hideDownloadCampaign.includes(
    campaignDetails?.status
  );

  // Download Each Guest Pdf Individually Handler
  // const campaignStatus = [
  //   "pending",
  //   "in-process",
  //   "failed",
  //   "scheduled",
  //   "drafted",
  //   "partially_failed",
  //   "cancel",
  //   "paused",
  // ];
  // const guestStatus = ["pending", "failed", "invalid", "cancelled", "deleted"];

  
  const deductCreditCampaign = ["failed", "invalid", "cancelled"];

  // A PDF-only campaign is paid for in full when it is created, so its
  // downloads are free however many there are. The API refuses to charge for
  // one either way; this is so the panel stops asking the customer to confirm
  // a deduction that will not happen, and stops blocking the download on a
  // credit balance it does not need.
  const downloadsAreFree = campaignDetails?.delivery_mode === "pdf_download";

  const getFormattedFileName = (template, guestName) => {
    if (!template) return guestName || "Guest";
    return template.replace(/\[\[name\]\]/g, guestName || "Guest");
  };

  const generateUniqueFileName = (items, currentItem, extension, imageIndex = null) => {
    const template = campaignDetails?.pdf_name;
    const baseName = getFormattedFileName(template, currentItem.name);
    const mobile = currentItem.mobile_number || "";
    
    const nameDuplicates = items.filter(item => item.name === currentItem.name);

    let fileNameBase = baseName;

    if (nameDuplicates.length > 1) {
      const nameMobileDuplicates = items.filter(
        item => item.name === currentItem.name && item.mobile_number === currentItem.mobile_number
      );

      if (nameMobileDuplicates.length > 1) {
        const duplicateIndex = nameMobileDuplicates.findIndex(item => item.id === currentItem.id);
        fileNameBase = `${baseName}_${mobile}_${duplicateIndex + 1}`;
      } else {
        fileNameBase = `${baseName}_${mobile}`;
      }
    }

    if (imageIndex !== null) {
      return `${fileNameBase}_${imageIndex + 1}.${extension}`;
    }

    return `${fileNameBase}.${extension}`;
  };


  const downloadEachPdf = async (item, isTestDownload = false) => {
    const availableCredits = user?.credits || 0;
    const requiresCredit =
      !downloadsAreFree &&
      deductCreditCampaign.includes((item?.status || "").toLowerCase());

    if (requiresCredit && availableCredits <= 0) {
      setSnackbarMessage("You have 0 credits. Please recharge before downloading.");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
      return;
    }

    setLoading(true);

    try {
      if (
        campaignDetails?.download_pdf_count >= 5 &&
        requiresCredit
      ) { 
        setPendingDownloadItem(item);
        setDownloadMode("single");
        setShowCreditModal(true);
        setLoading(false);
        return;
      }

      await downloadEachGuestPdfHanlder(item, isTestDownload);
    } catch (error) {
      console.error("Error fetching campaign details:", error);
      setSnackbarMessage("Failed to fetch campaign info");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
      setLoading(false);
    }
  };
  
  const downloadEachGuestPdfHanlder = async (item, isTestDownload = false) => {    
    if (Object.keys(item).length === 0) {
      setSnackbarMessage("No Data available to download");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
      return;
    }

    setLoading(true);

    try {
      const url = item?.campaign?.template_url;
      // const templateType = item?.campaign?.template_type; download_pdf_count

      // console.log("URLLLLLL", url);

      // if (!isTestDownload &&
      //   item?.campaign?.download_pdf_count >= 5 &&
      //   deductCreditCampaign.includes((item?.status || "").toLowerCase())
      // ) {
      //   setPendingDownloadItem(item); // Store item for later use
      //   setShowCreditModal(true);     // Show the modal
      //   setLoading(false);            // Stop spinner
      //   return;                       // Don't continue until user confirms
      // }
      if (
        !isTestDownload &&
        !downloadsAreFree &&
        deductCreditCampaign.includes((item?.status || "").toLowerCase())
      ) {
        await dispatch(
            deductCreditForDraftedCampaign({
              campaignId: item?.campaign?.id, // ✅ use current `item`
              guestId: item?.id,
            })
          ).unwrap();


        dispatch(userDetails());
      }



      // Case: PDF
      if (url?.endsWith(".pdf")) {
        const pdfBytes = await changeFont({
          ...item?.variables,
          name: item?.name,
        });

        const deletePageIndexes = [];
        const guestPos = item?.campaign?.variable_positions || {};

        Object.entries(guestPos).forEach(([key, value]) => {
          const text = item?.variables?.[key];
          if (text?.toString().trim().toUpperCase() === "DELETE") {
            deletePageIndexes.push(value.page - 1);
          }
        });

        const cleanedPdfBytes = await removePagesByIndex(
          pdfBytes,
          deletePageIndexes
        );

        const blob = new Blob([cleanedPdfBytes], { type: "application/pdf" });
        const template = campaignDetails?.pdf_name;
        const formattedBaseName = getFormattedFileName(template, item.name);
        const fileName = `${formattedBaseName}.pdf`;
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();

        if(!isTestDownload){
          const result = await dispatch(fetchCampaignById({ id: campaignDetails?.id })).unwrap();
          const campaign = result?.campaingDetails;

          setCampaignDetails(campaign);
        }


        setSnackbarMessage("PDF downloaded successfully");
        setSnackbarVariant("toast-success");

        // ✅ Case: Image (supports png, jpg, jpeg, gif, etc.)
      } else if (/\.(png|jpg|jpeg|gif|webp)$/i.test(url)) {
        const imageUrls = Array.isArray(item.imageUrls)
          ? item.imageUrls
          : [url];
        const guestPos = item?.campaign?.variable_positions || {};
        const variables = reconstructVariables(item);

        try {
          for (let i = 0; i < imageUrls.length; i++) {
            const imageUrl = imageUrls[i];
            const extension = imageUrl.split(".").pop().split(/#|\?/)[0];
            const template = campaignDetails?.pdf_name;
            const formattedBaseName = getFormattedFileName(template, item.name);
            const fileName = `${formattedBaseName}.${extension}`;

            // Load image as <img>
            const img = await new Promise((resolve, reject) => {
              const image = new Image();
              image.crossOrigin = "anonymous";
              image.src = imageUrl;

              image.onload = () => resolve(image);
              image.onerror = (e) => reject(new Error("Image load failed"));
            });

            // Create canvas and draw image
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            // Draw dynamic text over image
            for (const [key, value] of Object.entries(guestPos)) {
              const text = variables?.[key];
              if (!text || text.toString().trim().toUpperCase() === "DELETE")
                continue;

              const {
                x = 0,
                y = 0,
                size = 18,
                fontStyle = "Arial",
                color = [0, 0, 0],
                fontFile,
                align = "left", // Default to "left" if no alignment is provided
                width,
              } = value;

              try {
                if (fontFile) {
                  const font = new FontFace(fontStyle, `url(${fontFile})`);
                  await font.load();
                  document.fonts.add(font);
                }
              } catch (err) {
                console.warn(`Font load failed for ${fontStyle}`, err);
              }

              ctx.font = `${size}px ${fontStyle}`;
              ctx.fillStyle = `rgb(${color[0]}, ${color[1]}, ${color[2]})`;
              // ctx.fillText(text, x, y + size * 0.8); // baseline adjustment

              const textWidth = ctx.measureText(text).width; // Get width of the text
                        
              // Adjust the `x` position based on alignment (left, center, right)
              let adjustedX = x; // Default to left alignment
              if (align === "center") {
                  adjustedX = x + (width - textWidth) / 2; // Center align based on `width`
              } else if (align === "right") {
                  adjustedX = x + (width - textWidth); // Right align based on `width`
              }

              ctx.fillText(text, adjustedX, y + size * 0.8); // Baseline adjustment
            }

            // Export canvas to image blob
            const blob = await new Promise((resolve, reject) =>
              canvas.toBlob((blob) => {
                if (!blob) return reject(new Error("Canvas export failed"));
                resolve(blob);
              }, "image/png")
            );

            // Trigger download
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }

          if(!isTestDownload){
            const result = await dispatch(fetchCampaignById({ id: campaignDetails?.id })).unwrap();
            const campaign = result?.campaingDetails;

            setCampaignDetails(campaign);
          }
          setSnackbarMessage("Image downloaded successfully");
          setSnackbarVariant("toast-success");
        } catch (err) {
          console.error("Image download failed:", err);
          setSnackbarMessage("Failed to download image");
          setSnackbarVariant("toast-danger");
        } finally {
          setShowSnackbar(true);
        }
      } else {
        console.warn(`Unsupported file type for entry: ${item.name}`);
        setSnackbarMessage("Unsupported file type");
        setSnackbarVariant("toast-danger");
      }
    } catch (error) {
      console.error("Error while generating/downloading file:", error);
      setSnackbarMessage("Failed to download file");
      setSnackbarVariant("toast-danger");
    } finally {
      setShowSnackbar(true);
      setLoading(false);
    }
  };

  const handleConfirmCreditDeduction = async () => {
    if (!pendingDownloadItem) return;

    setShowCreditModal(false);
    setLoading(true);
    await downloadEachGuestPdfHanlder(pendingDownloadItem, false); // PASS the item
  };

  const handleSelectContacts = (e, item) => {
    // If single item is selected/unselected, check if it exceeds the 10-item limit
    const isSelected = selectedItems?.some(
      (contact) => contact?.id === item?.id
    );

    if (isSelected) {
      // Unselect the item
      setSelectedItems((prev) =>
        prev?.filter((contact) => contact?.id !== item?.id)
      );
    } else {
      // If selected items are less than 10, add the item
      if ((selectedItems?.length || 0) < 10) {
        setSelectedItems((prev) => [...(prev || []), item]);
      } else {
        // Show error if trying to select more than 10 items
        setSnackbarMessage(
          `You can only select up to 10 contacts. Unselect some contacts to select more.`
        );
        setSnackbarVariant("toast-danger");
        setShowSnackbar(true);
      }
    }
  };

  const reconstructVariables = (item) => {
    const variableKeys = item?.campaign?.variables || [];
    const result = {};

    for (const key of variableKeys) {
      let value = null;

      // Priority: guest variables > top-level fields
      if (item.variables?.hasOwnProperty(key)) {
        value = item.variables[key];
      } else if (key === "name") {
        value = item.name;
      } else if (key === "number") {
        value = item.mobile_number;
      }

      result[key] = value ?? "";
    }

    return result;
  };  

  /**
   * PDF-only campaigns are billed once when the campaign is created, so the
   * archive is built server-side and downloaded without any further credit
   * deduction. Guest PDFs are rendered by the Node service, streamed through
   * Laravel, and never assembled in the browser.
   */
  const handleDownloadPdfZip = async () => {
    setIsDownloadAllLoading(true);

    try {
      const response = await axiosapi.get(
        `/api/customer/campaign-pdf-zip/${id}`,
        { responseType: "blob" }
      );

      saveAs(
        new Blob([response.data], { type: "application/zip" }),
        `${campaignDetails?.name || "campaign"}-pdfs.zip`
      );
    } catch (error) {
      setSnackbarMessage("Failed to download the PDF archive.");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
    } finally {
      setIsDownloadAllLoading(false);
    }
  };

  const handleDownloadAllContacts = async () => {
    try {
      setIsDownloadAllLoading(true);
      if (!id) {
        setSnackbarMessage("Invalid campaign");
        setSnackbarVariant("toast-danger");
        setShowSnackbar(true);
        return;
      }

      if ((user?.credits || 0) <= 0) {
        setSnackbarMessage("You have 0 credits. Please recharge.");
        setSnackbarVariant("toast-danger");
        setShowSnackbar(true);
        return;
      }

      // setLoading(true);

      const res = await axiosapi.get(
        `/api/customer/all-campaign-guests/${id}`
      );      

      const allGuests = res?.data?.data?.data;

      if (allGuests.length > (user?.credits || 0)) {
        setSnackbarMessage(
          `You need ${allGuests.length - user.credits} more credits to download`
        );
        setSnackbarVariant("toast-danger");
        setShowSnackbar(true);
        setLoading(false);
        return;
      }

    const FREE_LIMIT = 5;

    const currentDownloadCount = campaignDetails?.download_pdf_count || 0;
    const remainingFree = Math.max(FREE_LIMIT - currentDownloadCount, 0);

    let allGuestsLength = allGuests.length;

    // Statuses are stored with an underscore, and this read "partially-failed"
    // until now, so a part-failed campaign never took this branch: it counted
    // every guest instead of only the ones still needing a PDF, and quoted a
    // charge the API would never make. The set matches the one
    // CampaignController::creditDeduction bills from.
    if (["partially_failed", "completed", "in-process"].includes(campaignDetails?.status)) {
      allGuestsLength = allGuests.filter((item)=> ["invalid", "failed", "pending", "cancelled"].includes(item.status)).length;      
    }

    const creditsToDeduct = Math.max(
      allGuestsLength - remainingFree,
      0
    );

    const willExceedFreeLimit = creditsToDeduct > 0;

    if (willExceedFreeLimit) {
      setPendingMultipleDownloadItems(allGuests);
      setPendingMultipleDeductionCount(creditsToDeduct); 
      setDownloadMode("all");
      setShowCreditModal(true);
      return;
    }

    console.log("processMultipleZip All Guest",allGuests);
      await processMultipleZip(allGuests);

      await dispatch(
        deductCreditForDraftedCampaign({
          campaignId: id,
          is_all_pdf: true,
        })
      ).unwrap();

      dispatch(userDetails());
      await fetchCampaignByIdData(false);
      // setLoading(false);

      // count credits to deduct
      // const deductionCount = allGuests.filter(item =>
      //   deductCreditCampaign.includes(
      //     (item?.status || "").toLowerCase()
      //   )
      // ).length;

      // console.log("Deduction count", deductionCount);
      

      // if (deductionCount > user.credits) {
      //   setSnackbarMessage(
      //     `You need ${deductionCount - user.credits} more credits`
      //   );
      //   setSnackbarVariant("toast-danger");
      //   setShowSnackbar(true);
      //   setLoading(false);
      //   return;
      // }

      // // same rule: >5 downloads → confirm
      // if (campaignDetails?.download_pdf_count >= 5 && deductionCount > 0) {
      //   setPendingMultipleDownloadItems(allGuests);
      //   setPendingMultipleDeductionCount(deductionCount);
      //   setDownloadMode("all");
      //   setShowCreditModal(true);
      //   setLoading(false);
      //   return;
      // }

      // if (deductionCount > 0) {
      //   await dispatch(
      //     deductCreditForDraftedCampaign({
      //       campaignId: id,
      //       is_zipped_download: true,
      //       deducted_credits: deductionCount,
      //     })
      //   ).unwrap();

      //   
      // }
  

    } catch (err) {
      console.error(err);
      setSnackbarMessage("Download all failed");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
      // setLoading(false);
    }finally{
      setIsDownloadAllLoading(false);
    }
  };


const handledownloadMultipleContact = async () => {
  if (!selectedItems || selectedItems.length === 0) {
    setSnackbarMessage(`No Items Available to Download`);
    setSnackbarVariant("toast-danger");
    setShowSnackbar(true);
    return;
  }

  if (!downloadsAreFree && (user?.credits || 0) <= 0) {
    setSnackbarMessage("You have 0 credits. Please recharge before downloading.");
    setSnackbarVariant("toast-danger");
    setShowSnackbar(true);
    return;
  }

  try {
    setLoading(true);

    // Count items that require credit deduction
    const deductionCount = downloadsAreFree
      ? 0
      : selectedItems.filter(item =>
          deductCreditCampaign.includes((item?.status || "").toLowerCase())
        ).length;

    if (deductionCount > 0 && deductionCount > (user?.credits || 0)) {
      const shortage = deductionCount - (user?.credits || 0);
      setSnackbarMessage(`You need ${shortage} more credit${shortage > 1 ? 's' : ''} to download.`);
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
      return;
    }


    // If more than 5 downloads already done → open modal
    if (campaignDetails?.download_pdf_count >= 5 && deductionCount > 0) {
      setPendingMultipleDownloadItems(selectedItems);
      setPendingMultipleDeductionCount(deductionCount);
      setDownloadMode("multiple");
      setShowCreditModal(true);
      setLoading(false);
      return;
    }

    // If no modal needed → proceed directly
    if (deductionCount > 0) {
      await dispatch(deductCreditForDraftedCampaign({
        campaignId: selectedItems[0]?.campaign?.id,
        is_zipped_download: true,
        deducted_credits: deductionCount
      })).unwrap();
      dispatch(userDetails());
    }

    await processMultipleZip(selectedItems);
    await dispatch(userDetails());
    await fetchCampaignByIdData(false);
  } catch (error) {
    console.error("Error checking campaign details:", error);
    setSnackbarMessage("Failed to check campaign details");
    setSnackbarVariant("toast-danger");
    setShowSnackbar(true);
    setLoading(false);
  }
};

// Each guest's PDF is a full copy of the template (often several MB), so a
// whole campaign held in memory runs the browser out of it. The ZIP is
// streamed instead: each file is written out as soon as it is built and then
// released. Where the browser can save straight to disk (Chrome, Edge) the
// customer picks the location up front; elsewhere the browser keeps the ZIP
// as a Blob, which it can spill to disk.
const pickZipFile = async () => {
  if (!window.showSaveFilePicker) return null;
  try {
    return await window.showSaveFilePicker({
      suggestedName: "contacts.zip",
      types: [{ description: "ZIP file", accept: { "application/zip": [".zip"] } }],
    });
  } catch (error) {
    if (error?.name === "AbortError") throw error;
    // The click that started the download has expired; fall back to a Blob.
    return null;
  }
};

const processMultipleZip = async (items) => {
  let fileHandle;
  try {
    fileHandle = await pickZipFile();
  } catch (error) {
    // The customer closed the save dialog.
    setSelectedItems([]);
    setLoading(false);
    return;
  }

  let done = 0;
  setZipProgress({ done, total: items.length });

  async function* zipEntries() {
    for (const entry of items) {
      for (const file of await buildZipEntryFiles(entry)) yield file;
      done++;
      setZipProgress({ done, total: items.length });
    }
  }

  let zipFailed = false;
  try {
    const zipResponse = downloadZip(zipEntries());
    if (fileHandle) {
      await zipResponse.body.pipeTo(await fileHandle.createWritable());
    } else {
      saveAs(await zipResponse.blob(), "contacts.zip");
    }
  } catch (error) {
    console.error("Error generating ZIP:", error);
    zipFailed = true;
  }

  setSnackbarMessage(zipFailed ? "ZIP creation failed" : "ZIP downloaded successfully");
  setSnackbarVariant(zipFailed ? "toast-danger" : "toast-success");
  setZipProgress(null);
  setSelectedItems([]);
  setShowSnackbar(true);
  setLoading(false);

  // Returns the files for one guest as { name, input } for the ZIP.
  async function buildZipEntryFiles(entry) {
    const files = [];
    const url = entry?.campaign?.template_url;

    try {
      if (url?.endsWith(".pdf")) {
        const pdfBytes = await changeFont({ ...entry?.variables, name: entry?.name });

        const deletePageIndexes = [];
        const variablePositions = entry?.campaign?.variable_positions || {};
        const variables = entry?.variables || {};

        Object.entries(variables).forEach(([key, value]) => {
          if (
            value?.toString().trim().toUpperCase() === "DELETE" &&
            variablePositions[key]?.page
          ) {
            deletePageIndexes.push(variablePositions[key].page - 1);
          }
        });

        const cleanedPdfBytes = await removePagesByIndex(pdfBytes, deletePageIndexes);
        const fileName = generateUniqueFileName(items, entry, "pdf");
        files.push({ name: fileName, input: cleanedPdfBytes });
      }

      else if (isImageFile(url)) {
        const imageUrls = Array.isArray(entry.imageUrls) ? entry.imageUrls : [url];
        const guestPos = entry?.campaign?.variable_positions || {};
        const variables = reconstructVariables(entry);

        for (let j = 0; j < imageUrls.length; j++) {
          const imageUrl = imageUrls[j];
          const fileExtension = imageUrl.split(".").pop().split(/#|\?/)[0];
          const fileName = generateUniqueFileName(items, entry, fileExtension, imageUrls.length > 1 ? j : null);

          const img = await new Promise((resolve, reject) => {
            const image = new Image();
            image.crossOrigin = "anonymous";
            image.src = imageUrl;
            image.onload = () => resolve(image);
            image.onerror = () => reject(new Error("Image load failed"));
          });

          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          for (const [key, pos] of Object.entries(guestPos)) {
            const text = variables?.[key];
            if (!text || text.toString().trim().toUpperCase() === "DELETE") continue;

            const {
              x = 0,
              y = 0,
              size = 18,
              fontStyle = "Arial",
              color = [0, 0, 0],
              fontFile,
              align = "left",
              width = canvas.width, // region width fallback
            } = pos;

            try {
              if (fontFile) {
                const font = new FontFace(fontStyle, `url(${fontFile})`);
                await font.load();
                document.fonts.add(font);
              }
            } catch (err) {
              console.warn(`Font load failed for ${fontStyle}`, err);
            }

            ctx.font = `${size}px ${fontStyle}`;
            ctx.fillStyle = `rgb(${color[0]}, ${color[1]}, ${color[2]})`;

            const textWidth = ctx.measureText(text).width;
            let adjustedX = x;

            if (align === "center") {
              adjustedX = x + (width - textWidth) / 2;
            } else if (align === "right") {
              adjustedX = x + (width - textWidth);
            }

            ctx.fillText(text, adjustedX, y + size * 0.8);
          }

          const blob = await new Promise((resolve, reject) =>
            canvas.toBlob((blob) => {
              if (!blob) return reject(new Error("Canvas export failed"));
              resolve(blob);
            }, "image/png")
          );

          files.push({ name: fileName, input: blob });
        }
      }

      else {
        console.warn(`Unsupported file type for ${entry.name}`);
      }
    } catch (error) {
      console.error(`Error processing ${entry.name}:`, error);
      setSnackbarMessage(`Error processing ${entry.name}`);
      setSnackbarVariant("toast-warning");
    }

    return files;
  }
};


const handleConfirmCreditDeductionMultiple = async () => {
  setShowCreditModal(false);
  setLoading(true);

  if (pendingMultipleDeductionCount > 0) {
    await dispatch(deductCreditForDraftedCampaign({
      campaignId: pendingMultipleDownloadItems[0]?.campaign?.id,
      is_zipped_download: true,
      deducted_credits: pendingMultipleDeductionCount
    })).unwrap();
    dispatch(userDetails());
  }

    await processMultipleZip(pendingMultipleDownloadItems);

    setPendingMultipleDownloadItems([]);
    setPendingMultipleDeductionCount(0);
  };

  const handleConfirmDownloadAll = async () => {
    if (!pendingMultipleDownloadItems.length) return;

    setShowCreditModal(false);
    // setLoading(true);
    setIsDownloadAllLoading(true);

    try {
      await processMultipleZip(pendingMultipleDownloadItems);

      await dispatch(
        deductCreditForDraftedCampaign({
          campaignId: id,
          is_all_pdf: true,
        })
      ).unwrap();

      dispatch(userDetails());

      await fetchCampaignByIdData(false);

    } catch (err) {
      console.error(err);
      setSnackbarMessage("Download all failed");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
    } finally {
      setPendingMultipleDownloadItems([]);
      setIsDownloadAllLoading(false);
      // setLoading(false);
    }
  };


  // Edit handler for Editing Campaign in Campaign Details
  const handleEditCampaign = (e) => {
    e.preventDefault();
    if (!campaignDetails) {
      setSnackbarMessage("campaign Id is missing");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
      return;
    }
    // Only check connection for personal WhatsApp, not for official WhatsApp
    const isOfficialWhatsApp = campaignDetails?.sender_type === "official";
    const isConnected = campaignDetails?.client_event?.whatsapp_client?.is_active || campaignDetails?.is_active;

    if (isOfficialWhatsApp || isConnected) {
      navigate(`/customers/update-campaign/${campaignDetails.id}`);
    } else {
      setSnackbarMessage("Please Connect Whatsapp!!");
      setSnackbarVariant("danger");
      setShowSnackbar(true);
    }
  };

  // Handler to Cancel Scheduled Campaign
  const handleCancelScheduleCampaign = (e) => {
    e.preventDefault();
    if (!campaignDetails) {
      setSnackbarMessage("campaign Id is missing");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
      return;
    }
    try {
      setIsSubmitting(true); // Set loading state
      setLoading(true); // Optional loader if you have one
      dispatch(cancelCampaign({ id: campaignDetails?.id })).then((res) => {
        if (res?.payload?.success === true) {
          setSnackbarMessage("Campaign Canceled successfully");
          setSnackbarVariant("toast-success");
          setShowSnackbar(true);
          navigate("/all-campaigns"); // Navigate to campaigns list
          dispatch(fetchAllCampaigns({})); // Refresh the campaigns list
          setIsSubmitting(false);
          setLoading(false); // Optional loader
        }
      });
    } catch (error) {
      setOpenCancelCampaign(false);
      setSnackbarMessage("Failed to cancel campaign");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
      setLoading(false); // Optional loader
    } finally {
      setOpenCancelCampaign(false);
    }
  };

  // Handler to Cancel In-progress Campaign
  const handleCancelInpProgressCampaign = async () => {
    try {
      setIsSubmitting(true); // Set loading state
      setLoading(true); // Optional loader if you have one
      const response = await axiosapi.post(
        `/api/customer/whatsapp/cancel-campaign`,
        { campaignId: campaignDetails?.id }
      );
      if (response.data.success) {
        setSnackbarMessage("Campaign Canceled successfully");
        setSnackbarVariant("toast-success");
        setShowSnackbar(true);
        navigate("/all-campaigns"); // Navigate to campaigns list
        dispatch(fetchAllCampaigns({})); // Refresh the campaigns list
        setLoading(false); // Optional loader
      }
    } catch (error) {
      setLoading(false);
      setSnackbarMessage("Failed to  cancel campaign");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Mirrors CampaignQueueService::HANDOVER_FROM. A draft reserved no credits
  // yet and a completed campaign has nothing outstanding, so neither can be
  // settled; the API refuses both either way.
  const canHandToHelpers =
    ["in-process", "paused", "partially_failed", "failed", "scheduled"].includes(
      campaignDetails?.status
    ) && campaignDetails?.delivery_mode !== "pdf_download";

  const handleOpenManualFallback = async () => {
    setIsManualBusy(true);

    try {
      const res = await dispatch(
        fetchManualSettlement({ campaignId: campaignDetails?.id })
      ).unwrap();

      if (!res?.success) {
        setSnackbarMessage(res?.message || "Could not work out what this would cost");
        setSnackbarVariant("toast-danger");
        setShowSnackbar(true);
        return;
      }

      setManualSettlement(res.data);
      setShowManualModal(true);
    } catch (err) {
      setSnackbarMessage("Could not work out what this would cost");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
    } finally {
      setIsManualBusy(false);
    }
  };

  const handleConfirmManualFallback = async () => {
    setIsManualBusy(true);

    try {
      const res = await dispatch(
        switchCampaignToManual({ campaignId: campaignDetails?.id })
      ).unwrap();

      if (!res?.success) {
        setSnackbarMessage(res?.message || "Could not hand this campaign over");
        setSnackbarVariant("toast-danger");
        setShowSnackbar(true);
        return;
      }

      setShowManualModal(false);
      setManualSettlement(null);
      setSnackbarMessage(
        `Handed over. ${res.data?.to_send_manually ?? 0} guests are now on your helpers' list.`
      );
      setSnackbarVariant("toast-success");
      setShowSnackbar(true);

      // Credits moved both ways and the campaign changed mode, so refresh both.
      dispatch(userDetails());
      await fetchCampaignByIdData(false);
    } catch (err) {
      setSnackbarMessage("Could not hand this campaign over");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
    } finally {
      setIsManualBusy(false);
    }
  };

  const handlePauseInProgressClick = async () => {
      try {
        setIsSubmitting(true); // Set loading state
        setLoading(true); // Optional loader if you have one
        console.log("bchdsbchkbdshcbhj");
        const response = await axiosapi.post(
          `/api/customer/whatsapp/pause-campaign`,
          {
            campaignId: campaignDetails?.id,
          }
        );
  
        if (response.data.success) {
          // alert("Campaign cancelled successfully.");
          // Optionally, refresh the campaign list or UI
          setSnackbarMessage("Campaign Paused successfully");
          setSnackbarVariant("toast-success");
          setShowSnackbar(true);
          navigate("/all-campaigns"); // Navigate to campaigns list
          dispatch(fetchAllCampaigns({})); // Refresh the campaigns list
          // dispatch(
          //   fetchEventDetail({
          //     offset: currentPage,
          //     limit,
          //     search: searchTerm,
          //     id: client_id,
          //     status: activeTab,
          //   })
          // ) // Refresh the campaigns list
        }
      } catch (error) {
        setLoading(false);
        setSnackbarMessage("Failed to pause campaign");
        setSnackbarVariant("toast-danger");
        setShowSnackbar(true);
      } finally {
        setIsSubmitting(false);
        setLoading(false); // Optional loader
        // setShowCancelConfirmModal(false);
      }
    };

  const handleResumeInProgressClick = async (selectedCampaign) => {
    try {
      setIsSubmitting(true); // Set loading state
      setLoading(true); // Optional loader if you have one
      console.log("bchdsbchkbdshcbhj");
      const response = await axiosapi.post(
        `/api/customer/whatsapp/resume-campaign`,
        {
          campaignId: selectedCampaign.id,
        }
      );

      if (response.data.success) {
        // alert("Campaign cancelled successfully.");
        // Optionally, refresh the campaign list or UI
        setSnackbarMessage("Campaign Resumed successfully");
        setSnackbarVariant("toast-success");
        setShowSnackbar(true);
        navigate("/all-campaigns"); // Navigate to campaigns list
        dispatch(fetchAllCampaigns({})); // Refresh the campaigns list
        // dispatch(
        //   fetchEventDetail({
        //     offset: currentPage,
        //     limit,
        //     search: searchTerm,
        //     id: client_id,
        //     status: activeTab,
        //   })
        // ) // Refresh the campaigns list
      }
    } catch (error) {
      setLoading(false);
      setSnackbarMessage("Failed to resume campaign");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
    } finally {
      setIsSubmitting(false);
      setLoading(false); // Optional loader
    }
  };

  // (hide and display message)
  const [isExpanded, setIsExpanded] = useState(false);

  // Function to handle "Show more" / "Show less"
  const toggleMessage = () => {
    setIsExpanded((prev) => !prev);
  };

  // Check if message is longer than 300 words
  const isLongMessage =
    campaignDetails?.message &&
    campaignDetails?.message?.split(" ").length > 100;

  const handleResendSingleRecipient = async (recipient) => {
    if (!recipient?.id || !recipient?.campaign?.id) {
      setSnackbarMessage("Missing recipient or campaign information.");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
      return;
    }

    if (resendLoadingId === recipient.id) return; // prevent re-entry

    setResendLoadingId(recipient.id);

    const payload = {
      campaignId: recipient?.campaign?.id,
      guestId: recipient?.id,
    };

    try {
      const response = await dispatch(resendSingleRecipientCampaign(payload));

      if (response.payload?.success) {
        setSnackbarMessage("Resent successfully.");
        setSnackbarVariant("toast-success");
        dispatch(userDetails());
      } else {
        setSnackbarMessage(response.payload?.message || "Failed to resend.");
        setSnackbarVariant("toast-danger");
      }
    } catch (error) {
      setSnackbarMessage("Resend failed: " + error.message);
      setSnackbarVariant("toast-danger");
    } finally {
      setResendLoadingId(null); // allow future resend
      setShowSnackbar(true);
    }
  };

//   const handlePauseResume = async () => {
//   try {
//     setLoading(true);
//     const apiUrl = isCampaignPaused
//       ? `${process.env.REACT_APP_WHATSAPP_API_URL}/api/whatsapp/resumeCampaign`
//       : `${process.env.REACT_APP_WHATSAPP_API_URL}/api/whatsapp/pauseCampaign`;

//     const response = await axios.post(apiUrl, {
//       campaignId: campaignDetails?.id,
//     });

//     console.log("Pause/Resume response:", response);

//     if (response.data.success) {
//       setIsCampaignPaused(!isCampaignPaused);
//       setSnackbarMessage(isCampaignPaused ? "Campaign Resumed" : "Campaign Paused");
//       setSnackbarVariant("toast-success");
//     } else {
//       setSnackbarMessage(response.data.message || "Action failed");
//       setSnackbarVariant("toast-danger");
//     }
//   } catch (error) {
//     console.error("Pause/Resume error:", error);
//     setSnackbarMessage("Something went wrong");
//     setSnackbarVariant("toast-danger");
//   } finally {
//     setShowSnackbar(true);
//     setLoading(false);
//   }
// };

  const confirmationTitle = downloadMode === "all" ? "Download All PDFs" : "Download Limit Exceeded";

  const confirmationMessage = downloadMode === "all"
    ? `Downloading all PDFs will deduct ${pendingMultipleDeductionCount} credit${
        pendingMultipleDeductionCount > 1 ? "s" : ""
      }. Do you want to proceed?`
    : "You’ve already downloaded 5 PDFs for free. Continuing now will deduct credits. Do you want to proceed?";



  return (
    <CommonLayout titles={titles}>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          onClose={() => setShowSnackbar(false)}
          show={showSnackbar}
          delay={3000}
          autohide
          bg={snackbarVariant}
          className="position-fixed top-3 end-0 me-3 shadow-none"
        >
          <Toast.Body className="d-flex align-items-center gap-1 lh-sm">
            <CheckmarkBadge04Icon
              width={18}
              height={18}
              color="#28c76f"
              strokeWidth="2"
            />
            <span className="text-capitalize">{snackbarMessage}</span>
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <Container fluid className="px-0">
        <div className="d-flex align-items-center justify-content-between">
          <BackPageBtnTab
            onClick={() => handleBackClick()}
            icon={
              <ArrowLeftIcon
                width={22}
                height={22}
                color="#444050"
                strokeWidth="2.2"
              />
            }
            title="Campaigns Details"
          />

          <div className="d-flex align-items-center gap-3">
            {campaignDetails?.status === "drafted" && (
              <>
                <CommomButton
                  onClick={handleDeleteCampaign}
                  icon={
                    <Delete02Icon
                      width={17}
                      height={17}
                      color="#ff4c51"
                      strokeWidth="2.5"
                    />
                  }
                  title="Delete"
                  className="btn-outline-danger common-one-shadow"
                />
              </>
            )}

            {(campaignDetails?.status === "pending" ||
              campaignDetails?.status === "drafted" ||
              campaignDetails?.status === "scheduled" ||
              campaignDetails?.status === "in-process") && (
              <Dropdown className="action-drops">
                <Dropdown.Toggle
                  variant="link"
                  className="text-white text-decoration-none"
                  id="dropdown-basic"
                >
                  <div className="d-flex align-items-center gap-1">
                    <ArrowDown01Icon
                      height={18}
                      width={18}
                      strokeWidth="1.8"
                      color="#ffffff"
                    />
                    <p>Action</p>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu className=" z-1 p-0">
                  <div className="d-flex flex-column action-drops-menu">
                    {(campaignDetails?.status === "pending" ||
                      campaignDetails?.status === "drafted") && (
                      <>
                        <Dropdown.Item
                          onClick={(e) => handleEditCampaign(e)}
                          className="p-0 d-flex align-items-center text-capitalize"
                        >
                          <MessageEdit01Icon
                            height={16}
                            width={16}
                            strokeWidth="1.8"
                            color="#8C8C8C"
                          />
                          <p>Edit</p>
                        </Dropdown.Item>
                      </>
                    )}

                    {campaignDetails?.status === "pending" &&
                      campaignDetails?.status === "drafted" &&
                      campaignDetails?.status === "scheduled" && (
                        <div className="divider"></div>
                      )}

                    {campaignDetails?.status === "scheduled" && (
                      <Dropdown.Item
                        className="p-0 d-flex align-items-center text-capitalize"
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenCancelCampaign(true);
                        }}
                      >
                        <CancelCircleIcon
                          height={16}
                          width={16}
                          strokeWidth="1.8"
                          color="#8C8C8C"
                        />
                        <p>Cancel Schedule</p>
                      </Dropdown.Item>
                    )}

                    {campaignDetails?.status === "in-process" && (
                      <>
                        <Dropdown.Item
                          className="p-0 d-flex align-items-center text-capitalize"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCancelInpProgressCampaign();
                          }}
                          >
                          <CancelCircleIcon
                            height={16}
                            width={16}
                            strokeWidth="1.8"
                            color="#8C8C8C"
                            />
                          <p>Cancel</p>
                        </Dropdown.Item>
                        <Dropdown.Item
                        // href="#/action-2"
                        className="p-0 d-flex align-items-center text-capitalize"
                        onClick={(e) => {
                            e.stopPropagation();
                            handlePauseInProgressClick();
                          }}
                        >
                          <PauseCircleIcon
                            height={16}
                            width={16}
                            strokeWidth="1.8"
                            color="#8C8C8C"
                            />
                          <p>Pause</p>
                        </Dropdown.Item>
                      </>
                    )}

                    {campaignDetails?.status === "paused" && (
                      <>
                        <Dropdown.Item
                          className="p-0 d-flex align-items-center text-capitalize"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleResumeInProgressClick();
                          }}
                          >
                          <PauseCircleIcon
                            height={16}
                            width={16}
                            strokeWidth="1.8"
                            color="#8C8C8C"
                            />
                          <p>Resume</p>
                        </Dropdown.Item>
                      </>
                    )}

                    {canHandToHelpers && (
                      <Dropdown.Item
                        className="p-0 d-flex align-items-center text-capitalize"
                        disabled={isManualBusy}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleOpenManualFallback();
                        }}
                      >
                        <UserGroup03Icon
                          height={16}
                          width={16}
                          strokeWidth="1.8"
                          color="#8C8C8C"
                        />
                        <p>Hand to helpers</p>
                      </Dropdown.Item>
                    )}

                    {/* <div className="divider"></div>  */}

                  <div className="divider"></div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            )}
          </div>
        </div>
        <Row
          className="mt-4"
          // onClick={handleClickOutside}
        >
          <Col xl={12} xxl={4}>
            <div className="grid gap-4 mb-4 mb-xxl-0">
              <Card className="rounded-2 g-col-12 g-col-lg-6 g-col-xxl-12 border-0 common-shadow w-100 common-card">
                <Card.Header className="px-0 pt-0 pb-4 bg-transparent border-0 common-card-header">
                  <div className="d-flex justify-content-between align-items-center gap-3">
                    <h5 className="fw-medium text-capitalize">
                      Customer Details
                    </h5>
                  </div>
                </Card.Header>
                <Card.Body className="p-0 common-card-body">
                  <Link
                    to=""
                    className="d-flex align-items-center gap-2 text-decoration-none mb-4 card-profile"
                  >
                    <div className=" rounded-circle d-flex align-items-center justify-content-center flex-shrink-1 user-icon">
                      <span className="text-uppercase fw-normal">
                        {getUserInitial(campaignDetails?.client_event?.name)}
                      </span>
                    </div>
                    <h6 className="fw-medium ms-1 text-capitalize">
                      {campaignDetails.client_event?.name}
                    </h6>
                  </Link>
                  <div className="d-flex flex-column gap-3 card-content">
                    <div>
                      <h6 className=" fw-medium mb-2 text-capitalize">
                        Contact info
                      </h6>
                      <p className="mb-1 fw-normal">
                        Email: {campaignDetails.client_event?.email}
                      </p>
                      <p className=" fw-normal">
                        Mobile: {campaignDetails.client_event?.contact_number}
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
              <Card className="rounded-2 g-col-12 g-col-lg-6 g-col-xxl-12 border-0 common-shadow w-100 common-card">
                <Card.Header className="px-0 pt-0 pb-4 bg-transparent border-0 common-card-header">
                  <div>
                    <h5 className="fw-medium text-capitalize mb-1">
                      Campaigns Details
                    </h5>
                  </div>
                </Card.Header>
                <Card.Body className="p-0 common-card-body">
                  <div className="grid row-gap-3 column-gap-0 column-gap-xxl-2 card-content mb-4">
                    <div className="g-col-12 g-col-xl-6">
                      <h6 className=" fw-medium mb-1 text-capitalize">
                        Campaigns Name
                      </h6>
                      <div className="d-flex align-items-center gap-2">
                        <p className="fw-normal margin-top-4">
                          {campaignDetails.name ? campaignDetails.name : "-"}
                        </p>
                      </div>
                    </div>
                    <div className="g-col-12 g-col-xl-6">
                      <h6 className=" fw-medium mb-1 text-capitalize">
                        Campaigns Type
                      </h6>
                      <div className="d-flex align-items-center gap-2">
                        <p className="fw-normal margin-top-4">
                          {/* {campaingDetails?.template_type ? campaingDetails?.template_type === "text" ? "Message" : campaingDetails?.template_type === "pdf" ? "PDF" : campaingDetails?.template_type === "image" ? "Image" : campaingDetails?.template_type : "-"} */}
                          {campaignDetails?.template_type
                            ? campaignDetails?.template_type === "text"
                              ? "Without Invitation File"
                              : campaignDetails?.template_type === "pdf" ||
                                campaignDetails?.template_type === "image"
                              ? "With Invitation File"
                              : campaignDetails?.template_type
                            : "-"}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="grid row-gap-3 column-gap-0 column-gap-xxl-2 mb-3 mb-xxl-4">
                    <div className="g-col-12 g-col-xl-6">
                      <div className="d-flex align-items-center status-content primary-status">
                        <div className=" rounded-2 d-flex align-items-center justify-content-center status-icon">
                          <SentIcon
                            width={28}
                            height={28}
                            color="#A5596A"
                            strokeWidth="1.5"
                          />
                        </div>
                        <div>
                          <h6
                            className={`fw-medium text-capitalize  ${
                              campaignDetails.status ===
                                ("drafted" ||
                                  "Drafted" ||
                                  "scheduled" ||
                                  "Scheduled") && "purple-cr"
                            }  ${
                              campaignDetails.status ===
                                ("in-process" || "In-Process") && "yellow-cr"
                            } ${
                              campaignDetails.status ===
                                ("completed" || "Completed") && "green-cr"
                            } ${
                              campaignDetails.status ===
                                ("partially failed" || "Partially Failed") &&
                              "red-cr"
                            } ${
                              campaignDetails.status ===
                                ("failed" || "Failed") && "red-cr"
                            } ${
                              campaignDetails.status ===
                                ("cancel" || "Cancel") && "red-cr"
                            } `}
                          >
                            {campaignDetails.status}
                          </h6>
                          <span className="text-capitalize">Status</span>
                        </div>
                      </div>
                    </div>
                    <div className="g-col-12 g-col-xl-6">
                      <div className="d-flex align-items-center status-content primary-status">
                        <div className=" rounded-2 d-flex align-items-center justify-content-center status-icon">
                          <UserIcon
                            width={28}
                            height={28}
                            color="#A5596A"
                            strokeWidth="1.5"
                          />
                        </div>
                        <div>
                          <h6 className="fw-medium text-capitalize">
                            {activeSubTab === "guests"
                              ? campaignDetailListWithoutRedux?.total_non_tested
                              : campaignDetailListWithoutRedux?.total_tested ||
                                0}
                          </h6>
                          <span className="text-capitalize">Recipient</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="grid row-gap-3 column-gap-0 column-gap-xxl-2 mb-3 mb-xxl-4">
                    <div className="g-col-12 g-col-xl-6">
                      <div className="d-flex align-items-center status-content primary-status">
                        <div className=" rounded-2 d-flex align-items-center justify-content-center status-icon">
                          <MessageDelay01Icon
                            width={28}
                            height={28}
                            color="#A5596A"
                            strokeWidth="1.5"
                          />
                        </div>
                        <div>
                          <h6 className="fw-medium text-capitalize">
                            {" "}
                            {campaignDetails?.delay_second_from
                              ? campaignDetails?.delay_second_from
                              : "-"}
                          </h6>
                          <span className="text-capitalize">Delay From</span>
                        </div>
                      </div>
                    </div>
                    <div className="g-col-12 g-col-xl-6">
                      <div className="d-flex align-items-center status-content primary-status">
                        <div className=" rounded-2 d-flex align-items-center justify-content-center status-icon">
                          <MessageDelay01Icon
                            width={28}
                            height={28}
                            color="#A5596A"
                            strokeWidth="1.5"
                          />
                        </div>
                        <div>
                          <h6 className="fw-medium text-capitalize">
                            {campaignDetails?.delay_second_to
                              ? campaignDetails?.delay_second_to
                              : "-"}
                          </h6>
                          <span className="text-capitalize">Delay To</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="grid row-gap-3 column-gap-0 column-gap-xxl-2 mb-3 mb-xxl-4">
                    <div className="g-col-12 g-col-xl-6">
                      <div className="d-flex align-items-center status-content primary-status">
                        <div className=" rounded-2 d-flex align-items-center justify-content-center status-icon">
                          <Coins01Icon
                            width={28}
                            height={28}
                            color="#A5596A"
                            strokeWidth="1.5"
                          />
                        </div>
                        <div>
                          <h6 className="fw-medium text-capitalize">
                            {campaignDetailListWithoutRedux?.total_sent || 0}
                          </h6>
                          <span className="text-capitalize">
                            Invitee Credit Used
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="g-col-12 g-col-xl-6">
                      <div className="d-flex align-items-center status-content primary-status">
                        <div className=" rounded-2 d-flex align-items-center justify-content-center status-icon">
                          <Coins02Icon
                            width={28}
                            height={28}
                            color="#A5596A"
                            strokeWidth="1.5"
                          />
                        </div>
                        <div>
                          <h6 className="fw-medium text-capitalize">
                            {campaignDetails?.client_guests_test_count}
                          </h6>
                          <span className="text-capitalize">
                            Test Credit Used
                          </span>
                        </div>
                      </div>
                    </div>

                    {["failed", "cancel"].includes(campaignDetails?.status) && (
                      <div className="g-col-12 g-col-xl-6">
                        <div className="d-flex align-items-center status-content primary-status">
                          <div className=" rounded-2 d-flex align-items-center justify-content-center status-icon">
                            <CoinsSwapIcon
                              width={28}
                              height={28}
                              color="#A5596A"
                              strokeWidth="1.5"
                            />
                          </div>
                          <div>
                            {(() => {
                              const recipients =
                                activeSubTab === "guests"
                                  ? campaignDetailListWithoutRedux?.total_non_tested ||
                                    0
                                  : campaignDetailListWithoutRedux?.total_tested ||
                                    0;

                              const inviteeUsed =
                                campaignDetailListWithoutRedux?.total_sent || 0;
                              const refundable = recipients - inviteeUsed;

                              return (
                                <>
                                  <h6 className="fw-medium text-capitalize">
                                    {refundable}
                                  </h6>
                                  <span className="text-capitalize">
                                    Refundable Credits
                                  </span>
                                </>
                              );
                            })()}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="grid row-gap-3 column-gap-0 column-gap-xxl-2 card-content ">
                    <div className="g-col-12 g-col-xl-6">
                      <h6 className=" fw-medium mb-1 text-capitalize">
                        Created On
                      </h6>
                      <p className="fw-normal">
                        {moment(campaignDetails.created_at).format(
                          "DD/MM/YYYY hh:mm A"
                        )}
                      </p>
                    </div>
                    <div className="g-col-12 g-col-xl-6">
                      <h6 className=" fw-medium mb-1 text-capitalize">
                        Updated On
                      </h6>
                      <p className="fw-normal">
                        {moment(campaignDetails.updated_at).format(
                          "DD/MM/YYYY hh:mm A"
                        )}
                      </p>
                    </div>
                  </div>

                  <div className="grid row-gap-3 column-gap-0 column-gap-xxl-2 card-content mt-3">
                    <div className="g-col-12 g-col-xl-6">
                      <h6 className=" fw-medium mb-1 text-capitalize">
                        Country Code
                      </h6>
                      <p className="fw-normal">
                        {campaignDetails.country_code
                          ? `+${campaignDetails.country_code}`
                          : "-"}
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>

              {/* {campaingDetails &&
                campaingDetails?.status &&
                campaingDetails?.status === "scheduled" && ( */}
              <Card className="rounded-2 g-col-12 g-col-lg-6 g-col-xxl-12 border-0 common-shadow w-100 common-card">
                <Card.Header className="px-0 pt-0 pb-4 bg-transparent border-0 common-card-header">
                  <div>
                    <h5 className="fw-medium text-capitalize">
                      {campaignDetails?.status === "scheduled"
                        ? "Schedule Details"
                        : "Timeline Details"}
                    </h5>
                  </div>
                </Card.Header>
                <Card.Body className="p-0 common-card-body">
                  <div className="grid row-gap-3 column-gap-0 column-gap-xxl-2 card-content">
                    {campaignDetails?.status === "scheduled" && (
                      <div className="g-col-12 g-col-xl-6">
                        <h6 className=" fw-medium mb-1 text-capitalize">
                          Schedule Date & Time
                        </h6>
                        <div className="d-flex align-items-center gap-2">
                          <p>
                            <Calendar03Icon
                              width={16}
                              height={16}
                              color="#A5596A"
                              strokeWidth="2"
                            />
                          </p>
                          <p className="fw-normal margin-top-4">
                            {campaignDetails?.scheduler_date
                              ? moment(campaignDetails?.scheduler_date).format(
                                  "DD-MM-YYYY hh:mm A"
                                )
                              : "-"}
                          </p>
                        </div>
                      </div>
                    )}
                    {/* <div className="g-col-12 g-col-xl-6">
                          <h6 className=" fw-medium mb-1 text-capitalize">
                            Sent Date & Time
                          </h6>
                          <div className="d-flex align-items-center gap-2">
                            <p>
                              <Calendar03Icon
                                width={16}
                                height={16}
                                color="#A5596A"
                                strokeWidth="2"
                              />
                            </p>
                            <p className="fw-normal margin-top-4">
                              {campaingDetails?.scheduler_date
                                ? moment(
                                    campaingDetails?.scheduler_date
                                  ).format("DD-MM-YYYY hh:mm A")
                                : "-"}
                            </p>
                          </div>
                        </div> */}
                  </div>
                  <div className="grid row-gap-3 column-gap-0 column-gap-xxl-2 card-content mt-3">
                    <div className="g-col-12 g-col-xl-6">
                      <h6 className=" fw-medium mb-1 text-capitalize">
                        Sent At
                      </h6>
                      <div className="d-flex align-items-center gap-2">
                        <p>
                          <Calendar03Icon
                            width={16}
                            height={16}
                            color="#A5596A"
                            strokeWidth="2"
                          />
                        </p>
                        <p className="fw-normal margin-top-4">
                          {campaignDetails?.sent_at
                            ? moment(campaignDetails?.sent_at).format(
                                "DD-MM-YYYY hh:mm A"
                              )
                            : "-"}
                        </p>
                      </div>
                    </div>
                    {campaignDetails?.status === "cancel" ? (
                      <div className="g-col-12 g-col-xl-6">
                        <h6 className=" fw-medium mb-1 text-capitalize">
                          Cancelled At
                        </h6>
                        <div className="d-flex align-items-center gap-2">
                          <p>
                            <Calendar03Icon
                              width={16}
                              height={16}
                              color="#A5596A"
                              strokeWidth="2"
                            />
                          </p>
                          <p className="fw-normal margin-top-4">
                            {campaignDetails?.cancelled_at
                              ? moment(campaignDetails?.cancelled_at).format(
                                  "DD-MM-YYYY hh:mm A"
                                )
                              : "-"}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div className="g-col-12 g-col-xl-6">
                        <h6 className=" fw-medium mb-1 text-capitalize">
                          Completed At
                        </h6>
                        <div className="d-flex align-items-center gap-2">
                          <p>
                            <Calendar03Icon
                              width={16}
                              height={16}
                              color="#A5596A"
                              strokeWidth="2"
                            />
                          </p>
                          <p className="fw-normal margin-top-4">
                            {campaignDetails?.completed_at
                              ? moment(campaignDetails?.completed_at).format(
                                  "DD-MM-YYYY hh:mm A"
                                )
                              : "-"}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </Card.Body>
              </Card>
              {/* // )} */}

              <Card className="rounded-2 g-col-12 g-col-lg-6 g-col-xxl-12 border-0 common-shadow w-100 common-card">
                <Card.Header className="px-0 pt-0 pb-4 bg-transparent border-0 common-card-header">
                  <div>
                    <h5 className="fw-medium text-capitalize mb-1">Message</h5>
                  </div>
                </Card.Header>
                <Card.Body className="p-0 common-card-body">
                  {campaignDetails.message ? (
                    <div className="d-flex flex-column gap-3 card-content">
                      <p
                        className="fw-normal"
                        style={{ whiteSpace: "pre-wrap" }}
                      >
                        {isLongMessage && !isExpanded
                          ? campaignDetails.message.substring(0, 100) + "..."
                          : campaignDetails.message}
                      </p>
                      {isLongMessage && (
                        <button
                          type="button"
                          className="btn btn-link p-0 fw-medium text-start"
                          onClick={toggleMessage}
                        >
                          {isExpanded ? "View less" : "View More"}
                        </button>
                      )}
                    </div>
                  ) : (
                    <div className="text-center w-100 blank-table-view">
                      <h5>No message available</h5>
                    </div>
                  )}
                </Card.Body>
              </Card>

              <Card className="rounded-2 g-col-12 g-col-lg-6 g-col-xxl-12 border-0 common-shadow w-100 common-card">
                <Card.Header className="px-0 pt-0 pb-4 bg-transparent border-0 common-card-header">
                  <h6 className=" fw-medium mb-3 text-capitalize">
                    Invitation/PDF File
                  </h6>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex flex-column">
                      <h6 className=" fw-medium mb-1 text-capitalize">
                        Actual PDF Name
                      </h6>
                      <p className="fw-normal margin-top-4">
                        {campaignDetails?.original_pdf_name
                          ? campaignDetails?.original_pdf_name
                          : "-"}
                      </p>
                    </div>
                    <div className="d-flex flex-column">
                      <h6 className=" fw-medium mb-1 text-capitalize">
                        Customize PDF Name
                      </h6>
                      <p className="fw-normal margin-top-4">
                        {campaignDetails?.pdf_name
                          ? campaignDetails?.pdf_name
                          : "-"}
                      </p>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body
                  className="p-0 common-card-body "
                  // onClick={() => {
                  //   setIndex(index);
                  //   setIsOpen(true);
                  // }}
                >
                  {documentUrl ? (
                    <div className="d-flex align-items-center justify-content-center gap-3 card-content">
                      <div
                        className={`${
                          documentUrl ? "pdf-view border overflow-hidden" : null
                        }`}
                      >
                        {campaignDetails?.template_type === "pdf" ? (
                          <>
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                handleOpenPdfView();
                                setIndex(index);
                                // setIsOpen(true);
                              }}
                              className="cursor-pointer h-100"
                            >
                              <Document
                                file={documentUrl}
                                onLoadSuccess={onDocumentLoadSuccess}
                                onLoadError={(error) =>
                                  console.log(
                                    "Error while loading document:",
                                    error
                                  )
                                }
                                onSourceError={(error) =>
                                  console.log(
                                    "Error while fetching document source:",
                                    error
                                  )
                                }
                                className="h-100 w-100"
                              >
                                <Page
                                  width={400}
                                  className="h-100 w-100"
                                  pageNumber={pdfCurrentPage}
                                  renderTextLayer={false}
                                  renderAnnotationLayer={false}
                                />
                                {/* {Array.from(new Array(numPages), (el, index) => (
                                      <Page
                                        key={`page_${index + 1}`}
                                        className={`h-100 w-100 ${isZoomed ? "shadow-xl" : ""}`}
                                        width={isZoomed ? 800 : 400} // Adjust width for zoomed/non-zoomed state
                                        pageNumber={isZoomed ? index + 1 : pdfCurrentPage} // Display current page in non-zoomed view
                                        renderTextLayer={false}
                                        renderAnnotationLayer={false}
                                      />
                                    ))} */}
                              </Document>
                            </div>
                            {/* </div>
                              </div> */}
                          </>
                        ) : campaignDetails?.template_type?.startsWith(
                            "image"
                          ) ? (
                          <Zoom>
                            <img
                              src={documentUrl}
                              alt="Campaign Document"
                              style={{ maxWidth: "100%" }}
                            />
                          </Zoom>
                        ) : (
                          <p>Unsupported document type</p>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="text-center w-100 blank-table-view">
                      <h5>No PDF available</h5>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </div>
          </Col>
          <Col xl={12} xxl={8}>
            <div className="px-0 custpmize-grid gap-2 mb-2">
              <div>
                <SmallWidgets
                  count={
                    activeSubTab === "guests"
                      ? campaignDetailListWithoutRedux?.total_non_tested
                      : campaignDetailListWithoutRedux?.total_tested || 0
                  }
                  title="Total Recipients"
                  icon={
                    <Message01Icon
                      width={26}
                      height={26}
                      color="#444050"
                      strokeWidth="1.5"
                    />
                  }
                  onClick={() => handleStatusClick("all")}
                  className={activeTabStatus === "all" && "active"}
                />
              </div>
              <div>
                <SmallWidgets
                  count={campaignDetailListWithoutRedux?.total_pending || 0}
                  title="In Queue"
                  icon={
                    <MessageSearch01Icon
                      width={26}
                      height={26}
                      color="#444050"
                      strokeWidth="1.5"
                    />
                  }
                  onClick={() => handleStatusClick("pending")}
                  className={activeTabStatus === "pending" && "active"}
                />
              </div>
              <div>
                <SmallWidgets
                  count={campaignDetailListWithoutRedux?.total_sent || 0}
                  title="Sent"
                  icon={
                    <SentIcon
                      width={26}
                      height={26}
                      color="#444050"
                      strokeWidth="1.5"
                    />
                  }
                  onClick={() => handleStatusClick("sent")}
                  className={activeTabStatus === "sent" && "active"}
                />
              </div>
              <div>
                <SmallWidgets
                  count={campaignDetailListWithoutRedux?.total_delivered || 0}
                  title="Delivered"
                  icon={
                    <MessageDone01Icon
                      width={26}
                      height={26}
                      color="#444050"
                      strokeWidth="1.5"
                    />
                  }
                  onClick={() => handleStatusClick("delivered")}
                  className={activeTabStatus === "delivered" && "active"}
                />
              </div>
            </div>
            <div className="px-0 custpmize-grid-5 gap-2 mb-4">
              <div>
                <SmallWidgets
                  count={campaignDetailListWithoutRedux?.total_read || 0}
                  title="Seen"
                  icon={
                    <MessagePreview01Icon
                      width={26}
                      height={26}
                      color="#444050"
                      strokeWidth="1.5"
                    />
                  }
                  onClick={() => handleStatusClick("seen")}
                  className={activeTabStatus === "seen" && "active"}
                />
              </div>
              <div>
                <SmallWidgets
                  count={campaignDetailListWithoutRedux?.total_failed || 0}
                  title="Failed"
                  icon={
                    <MessageCancel01Icon
                      width={26}
                      height={26}
                      color="#444050"
                      strokeWidth="1.5"
                    />
                  }
                  onClick={() => handleStatusClick("failed")}
                  className={activeTabStatus === "failed" && "active"}
                />
              </div>
              <div>
                <SmallWidgets
                  count={campaignDetailListWithoutRedux?.total_invalid || 0}
                  title="Invalid"
                  icon={
                    <MessageQuestionIcon
                      width={26}
                      height={26}
                      color="#444050"
                      strokeWidth="1.5"
                    />
                  }
                  onClick={() => handleStatusClick("invalid")}
                  className={activeTabStatus === "invalid" && "active"}
                />
              </div>
              <div>
                <SmallWidgets
                  count={campaignDetailListWithoutRedux?.not_seen || 0}
                  title="Not-Seen"
                  icon={
                    <MessagePreview02Icon
                      width={26}
                      height={26}
                      color="#444050"
                      strokeWidth="1.5"
                    />
                  }
                  onClick={() => handleStatusClick("not_seen")}
                  className={activeTabStatus === "not_seen" && "active"}
                />
              </div>
              <div>
                <SmallWidgets
                  count={campaignDetailListWithoutRedux?.total_cancelled || 0}
                  title="Cancelled"
                  icon={
                    <MessagePreview02Icon
                      width={26}
                      height={26}
                      color="#444050"
                      strokeWidth="1.5"
                    />
                  }
                  onClick={() => handleStatusClick("cancelled")}
                  className={activeTabStatus === "cancelled" && "active"}
                />
              </div>
            </div>

            {campaignDetails?.status === "in-process" && (
              <div className="mb-4">
                <div className="card border-0 shadow-sm">
                  <div className="card-body p-4">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <h6 className="mb-0 fw-semibold text-dark">Campaign Progress</h6>
                      <div className="d-flex align-items-center gap-2">
                        <div className="spinner-grow spinner-grow-sm text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <small className="text-muted">Processing...</small>
                      </div>
                    </div>
                    <div className="progress" style={{ height: '24px', backgroundColor: '#e9ecef' }}>
                      <div 
                        className="progress-bar progress-bar-striped progress-bar-animated bg-primary" 
                        role="progressbar" 
                        style={{ 
                          width: `${
                            ((activeSubTab === 'guests' ? latestGuestList?.total_sent : 0 || 0) + 
                            //  (latestGuestList?.total_delivered || 0) + 
                            //  (latestGuestList?.total_seen || 0) + 
                             (activeSubTab === 'guests' ? latestGuestList?.total_failed : 0 || 0) + 
                             (activeSubTab === 'guests' ? latestGuestList?.total_invalid : 0 || 0) + 
                             (activeSubTab !== 'guests' ? latestGuestList?.total_tested : 0 || 0) + 
                             (activeSubTab === 'guests' ? latestGuestList?.total_cancelled : 0 || 0)) / 
                            // (latestGuestList?.total_tested 
                            //   ? latestGuestList?.total_tested 
                            //   : latestGuestList?.total_non_tested || 1) * 100
                            (activeSubTab === 'guests' ? latestGuestList?.total_non_tested : latestGuestList?.total_tested) * 100
                          }%`,
                          transition: 'width 0.5s ease-in-out'
                        }}
                        aria-valuenow={
                          ((activeSubTab === 'guests' ? latestGuestList?.total_sent : 0 || 0) + 
                          //  (latestGuestList?.total_delivered || 0) + 
                          //  (latestGuestList?.total_seen || 0) + 
                           (activeSubTab === 'guests' ? latestGuestList?.total_failed : 0 || 0) + 
                           (activeSubTab === 'guests' ? latestGuestList?.total_invalid : 0 || 0) + 
                           (activeSubTab !== 'guests' ? latestGuestList?.total_tested : 0 || 0) + 
                           (activeSubTab === 'guests' ? latestGuestList?.total_cancelled : 0 || 0)) / 
                          // (latestGuestList?.total_tested 
                          //   ? latestGuestList?.total_tested 
                          //   : latestGuestList?.total_non_tested || 1) * 100
                          (activeSubTab === 'guests' ? latestGuestList?.total_non_tested : latestGuestList?.total_tested) * 100
                        } 
                        aria-valuemin="0" 
                        aria-valuemax="100"
                      >
                        <span className="fw-semibold">
                          {Math.round(
                            ((activeSubTab === 'guests' ? latestGuestList?.total_sent : 0 || 0) + 
                            //  (latestGuestList?.total_delivered || 0) + 
                            //  (latestGuestList?.total_seen || 0) + 
                             (activeSubTab === 'guests' ? latestGuestList?.total_failed : 0 || 0) + 
                             (activeSubTab === 'guests' ? latestGuestList?.total_invalid : 0 || 0) + 
                             (activeSubTab !== 'guests' ? latestGuestList?.total_tested : 0 || 0) + 
                             (activeSubTab === 'guests' ? latestGuestList?.total_cancelled : 0 || 0)) / 
                            // (latestGuestList?.total_tested 
                            //   ? latestGuestList?.total_tested 
                            //   : latestGuestList?.total_non_tested || 1) * 100
                            (activeSubTab === 'guests' ? latestGuestList?.total_non_tested : latestGuestList?.total_tested) * 100
                          )}%
                        </span>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                      <small className="text-muted">
                        {(latestGuestList?.total_sent || 0) + 
                        //  (latestGuestList?.total_delivered || 0) + 
                        //  (latestGuestList?.total_seen || 0) + 
                         (latestGuestList?.total_failed || 0) + 
                         (latestGuestList?.total_invalid || 0) + 
                         (latestGuestList?.total_cancelled || 0)} processed
                      </small>
                      <small className="text-muted">
                        {latestGuestList?.total_pending || 0} remaining
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            )}


            <div className="mb-4">
              <NavTabs
                defaultActiveKey={activeSubTab}
                id="uncontrolled-tab-example"
                onSelect={handleSubTabSelect}
                tabsData={CampaignsDataTabs}
              />
            </div>
            <div className="bg-white rounded-2 common-shadow custom-style-3">
              <div className="p-4 d-flex align-items-center justify-content-between gap-4">
                <div className="position-relative">
                  <Input
                    type="search"
                    value={searchTerm}
                    placeholder="Search"
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(0);
                    }}
                    className="shadow-none base-search  pe-4"
                  />

                  {searchTerm && (
                    <div>
                      <Cancel01Icon
                        height={14}
                        width={14}
                        color="#A5596A"
                        strokeWidth="3"
                        onClick={() => setSearchTerm("")}
                        className="cursor-pointer position-absolute top-50 translate-middle-y end-0 me-2"
                      />
                    </div>
                  )}
                </div>

                <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap">
                  {/* <CommomButton 
                      onClick={() => handledownloadMultipleContact()}  
                      title="Download" 
                      className="btn-primary common-one-shadow" 
                      subClassName="gap-1" 
                      disabled={selectedItems?.length === 0}/> */}

                  
                        {/* <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 250 }}
                            overlay={<TT id="button-tooltip">Test Download</TT>}
                          >
                            <Button
                              variant="link"
                              onClick={() => {
                                const firstEvent =
                                  campaignDetailListWithoutRedux?.data?.[0];
                                if (firstEvent) {
                                  downloadEachGuestPdfHanlder(firstEvent, true);
                                } else {
                                  setSnackbarMessage("No recipient data found.");
                                  setSnackbarVariant("toast-danger");
                                  setShowSnackbar(true);
                                }
                              }}
                              className="btn-outline-primary-icon d-flex align-items-center justify-content-center"
                            >
                              <FileDownloadIcon
                                width={17}
                                height={17}
                                color="#A5596A"
                                strokeWidth="2.5"
                              />
                            </Button>
                          </OverlayTrigger> */}
                        
                          {/* {campaignDetails?.status === "in-process" && (
                            <Button
                              variant="link"
                              onClick={handlePauseResume}
                              className="custom-outline-btn btn-outline-primary d-flex align-items-center justify-content-center gap-1 py-2 text-decoration-none"
                            >
                              {isCampaignPaused ? (
                                <>
                                  <PlayIcon width={16} height={16} color="#A5596A" />
                                  <span>Resume</span>
                                </>
                              ) : (
                                <>
                                  <PauseIcon width={16} height={16} color="#A5596A" />
                                  <span>Pause</span>
                                </>
                              )}
                            </Button>
                          )} */}

                     {campaignDetailListWithoutRedux?.data?.length > 0 &&
                       campaignDetails?.template_type !== "text" && (
                      <>
                          <Button
                            variant="link"
                            onClick={() => {
                              const firstEvent =
                                campaignDetailListWithoutRedux?.data?.[0];
                              if (firstEvent) {
                                downloadEachGuestPdfHanlder(firstEvent, true);
                              } else {
                                setSnackbarMessage("No recipient data found.");
                                setSnackbarVariant("toast-danger");
                                setShowSnackbar(true);
                              }
                            }}
                            className="custom-outline-btn btn-outline-primary d-flex align-items-center justify-content-center gap-1 py-2 text-decoration-none"
                          >
                            <DownloadIcon
                              width={16}
                              height={16}
                              color="#A5596A"
                              // strokeWidth="2.5"
                            />
                            <span>Download Test</span>
                          </Button>
                      </>
                    )}

                  {!hideDownloadColumn &&
                        campaignDetails?.template_type !== "text" &&  (
                    <>
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 250 }}
                        overlay={<TT id="button-tooltip">Download</TT>}
                      >
                        <Button
                          variant="link"
                          onClick={() => handledownloadMultipleContact()}
                          disabled={selectedItems?.length === 0}
                          className="btn-outline-primary-icon d-flex align-items-center justify-content-center"
                        >
                          <FileDownloadIcon
                            width={17}
                            height={17}
                            color="#A5596A"
                            strokeWidth="2.5"
                          />
                        </Button>
                      </OverlayTrigger>
                    </>
                  )}
                  
                  {campaignDetails?.delivery_mode === "pdf_download" && (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<TT>Download all PDFs (ZIP)</TT>}
                    >
                      <Button
                        variant="link"
                        onClick={handleDownloadPdfZip}
                        disabled={isDownloadAllLoading}
                        className="btn-outline-primary-icon d-flex align-items-center justify-content-center"
                      >
                        {isDownloadAllLoading ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          <DownloadAllIcon />
                        )}
                      </Button>
                    </OverlayTrigger>
                  )}

                  {zipProgress && (
                    <span className="small text-muted text-nowrap">
                      Preparing {zipProgress.done} / {zipProgress.total}
                    </span>
                  )}

                  {
                    campaignDetails?.template_type !== "text" &&
                    campaignDetails?.delivery_mode !== "pdf_download" &&  (
                      <OverlayTrigger placement="bottom" overlay={<TT>Download All</TT>}>
                        <Button
                          variant="link"
                          onClick={handleDownloadAllContacts}
                          disabled={isDownloadAllLoading}
                          className="btn-outline-primary-icon d-flex align-items-center justify-content-center"
                        >
                          {isDownloadAllLoading ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            />
                          ) : (
                            <DownloadAllIcon />
                          )}
                        </Button>
                      </OverlayTrigger>
                    )
                  }            

                  {activeTabStatus === "failed" && showBtnIfArrHasPdfOrImg && (
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 250 }}
                      overlay={<TT id="button-tooltip">Download Failed File</TT>}
                    >
                      <Button
                        variant="link"
                        onClick={() =>
                          downloadFailedZip(
                            campaignDetailListWithoutRedux?.data,
                            "failed"
                          )
                        }
                        disabled={
                          campaignDetailListWithoutRedux?.data?.length === 0
                        }
                        className="btn-outline-primary-icon d-flex align-items-center justify-content-center"
                      >
                        <FailedIcon
                          width={17}
                          height={17}
                          color="#A5596A"
                          strokeWidth="1.5"
                        />
                      </Button>
                    </OverlayTrigger>
                  )}

                  {activeTabStatus === "invalid" && showBtnIfArrHasPdfOrImg && (
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 250 }}
                      overlay={
                        <TT id="button-tooltip">Download Invalid File</TT>
                      }
                    >
                      <Button
                        variant="link"
                        onClick={() =>
                          downloadFailedZip(
                            campaignDetailListWithoutRedux?.data,
                            "invalid"
                          )
                        }
                        disabled={
                          campaignDetailListWithoutRedux?.data?.length === 0
                        }
                        className="btn-outline-primary-icon d-flex align-items-center justify-content-center"
                      >
                        <InvalidIcon
                          width={17}
                          height={17}
                          color="#A5596A"
                          strokeWidth="1.5"
                        />
                      </Button>
                    </OverlayTrigger>
                  )}

                  {activeTabStatus === "failed" && (
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 250 }}
                      overlay={<TT id="button-tooltip">Resend</TT>}
                    >
                      <Button
                        variant="link"
                        onClick={() => handleResendFailedMessagesClick()}
                        disabled={
                          campaignDetailListWithoutRedux?.data?.length === 0 || campaignDetails?.status === "in-process"
                        }
                        className="btn-outline-primary-icon d-flex align-items-center justify-content-center"
                      >
                        <ResendIcon width={16} height={16} color="#A5596A" />
                      </Button>
                    </OverlayTrigger>
                  )}

                     {campaignDetailListWithoutRedux?.total_pending > 0 
                     && (
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 250 }}
                        overlay={<TT id="button-tooltip">Restart</TT>}
                      >
                        <Button
                          variant="link"
                          onClick={() => handleRestartCampaignClick()}
                          disabled={campaignDetailListWithoutRedux?.data?.length === 0 || campaignDetails?.status === "in-process"}
                          className="btn-outline-primary-icon d-flex align-items-center justify-content-center"
                          style={{ marginLeft: 4 }}
                        >
                          <RestartIcon width={16} height={16} color="#A5596A" />
                        </Button>
                      </OverlayTrigger>
                    )}

                  {campaignDetails?.status !== "drafted" && (
                    <>
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 250 }}
                        overlay={<TT id="button-tooltip">Export</TT>}
                      >
                        <Button
                          variant="link"
                          onClick={() => handleExportClick()}
                          className="btn-outline-primary-icon d-flex align-items-center justify-content-center"
                        >
                          <ExportIcon
                            width={16}
                            height={16}
                            color="#A5596A"
                            // strokeWidth="2.5"
                          />
                        </Button>
                      </OverlayTrigger>

                      {activeTabStatus === "invalid" && (
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 250 }}
                          overlay={<TT id="button-tooltip">Make a Copy</TT>}
                        >
                          <Button
                            variant="link"
                            onClick={() => handleOpenModal()}
                            // disabled={campaingDetailsData?.data?.length === 0}
                            className="btn-outline-primary-icon d-flex align-items-center justify-content-center"
                          >
                            <Copy02Icon
                              width={17}
                              height={17}
                              color="#A5596A"
                              strokeWidth="2.5"
                            />
                          </Button>
                        </OverlayTrigger>
                      )}

                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 250 }}
                        overlay={<TT id="button-tooltip">Refresh</TT>}
                      >
                        <Button
                          variant="link"
                          onClick={() => handleRefreshClick()}
                          className="btn-outline-primary-icon d-flex align-items-center justify-content-center"
                        >
                          <ReloadIcon
                            width={17}
                            height={17}
                            color="#A5596A"
                            strokeWidth="2.5"
                          />
                        </Button>
                      </OverlayTrigger>
                    </>
                  )}
                </div>
              </div>
              <div className="table-responsive campaigns-details-tbl-list">
                <Table className="common-table">
                  <thead>
                    <tr className="position-sticky top-0 z-2">
                      <th className="">
                        <div className="table-br">
                          {/* ignor this p Tag - Dont Remove p Tag and Do not Change Content */}
                          <p className="opacity-0">ck</p>
                        </div>
                      </th>
                      <th>
                        <div className="table-br">
                          <p>Id</p>
                        </div>
                      </th>

                      <th>
                        <div className="table-br">
                          <p>Name</p>
                        </div>
                      </th>

                      <th>
                        <div className="table-br">
                          <p>Mobile</p>
                        </div>
                      </th>

                      <th>
                        <div className="table-br">
                          <p>Status</p>
                        </div>
                      </th>

                      <th>
                        <div className="table-br">
                          <p>Sent Status</p>
                        </div>
                      </th>

                      <th>
                        <div className="table-br">
                          <p>Delivery Status</p>
                        </div>
                      </th>

                      <th>
                        <div className="table-br">
                          <p>Seen Status</p>
                        </div>
                      </th>

                      {!hideDownloadColumn &&
                        campaignDetails?.template_type !== "text" && (
                          <th>
                            <div className="table-br">
                              <p>Download</p>
                            </div>
                          </th>
                        )}

                      {!["drafted", "scheduled", "in-process"].includes(campaignDetails?.status) && (
                        <th>
                          <div className="table-br">
                            <p>Resend</p>
                          </div>
                        </th>
                      )}

                    </tr>
                  </thead>
                  <tbody>
                    {tableLoading ? (
                      <tr>
                        <td colSpan="9">
                          <TableLoader />
                        </td>
                      </tr>
                    ) : campaignDetailListWithoutRedux?.data?.length === 0 ? (
                      <tr className="border-none-force">
                        <td
                          colSpan="9"
                          className="text-center"
                          // style={{position: "relative", left: "330px"}}
                          // colSpan={getColumnsForActiveTab(activeTab).length + 1}
                        >
                          <div className="text-center w-100 blank-table-view">
                            <Img
                              src="/assets/images/component-common/blank-table.png"
                              alt="Blank-Table-Data-Image"
                              className="img-fluid"
                            />
                            <div className="mt-3">
                              <h5 className="fw-medium">
                                Couldn't find any data.
                              </h5>
                              <p className="pt-2 mt-1">
                                This report does not contain any points.
                                {/* Try to
                                change your filter and try again. */}
                              </p>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      // campaignDetailListWithoutRedux?.data?.map((event, i) => {
                      campaignDetailListWithoutRedux?.data?.map((event, i) => {
                        // console.log("Event", event);
                        return (
                          <tr key={i}>
                            <td className="table-check ">
                              <Checkbox
                                onChange={(e) => handleSelectContacts(e, event)}
                                checked={selectedItems.some(
                                  (contact) => contact.id === event.id
                                )}
                                // disabled={
                                //   ["pending", "failed", "invalid", "cancelled", "deleted"].includes(
                                //     event?.status?.toLowerCase()
                                //   )
                                // }
                                className="sm-checkbox d-flex align-items-center"
                              />
                            </td>

                            {/* <td className="table-svg">
                                {event?.status === "failed" ? (
                                  <InformationCircleIcon
                                    height={16}
                                    width={16}
                                    strokeWidth="2"
                                    color="#ff4c51"
                                  />
                                ) : event?.status === "sent" ? (
                                  <SentIcon
                                    height={16}
                                    width={16}
                                    strokeWidth="2"
                                    color="#A5596A"
                                  />
                                ) : event?.status === "read" ? (
                                  <EyeIcon
                                    height={16}
                                    width={16}
                                    strokeWidth="2"
                                    color="#A5596A"
                                  />
                                ) : event?.status === "delivered" ? (
                                  <CheckmarkCircle04Icon
                                    height={16}
                                    width={16}
                                    strokeWidth="2"
                                    color="#28c76f"
                                  />
                                ) : event?.status === "invalid" ? (
                                  <MessageQuestionIcon
                                    height={16}
                                    width={16}
                                    strokeWidth="2"
                                    color="#ff4c51"
                                  />
                                ) : event?.status === "pending" ? (
                                  <Clock05Icon
                                    height={16}
                                    width={16}
                                    strokeWidth="2"
                                    color="#ff9f43"
                                  />
                                ) : event?.status === "cancel" ? (
                                  <CancelCircleHalfDotIcon
                                    height={16}
                                    width={16}
                                    strokeWidth="2"
                                    color="#ff4c51"
                                  />
                                ) : (
                                  <InformationCircleIcon
                                    height={16}
                                    width={16}
                                    strokeWidth="2"
                                    color="#A5596A"
                                  />
                                )} 
                              </td
                              > */}
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <TT id="tooltip-top">
                                      {event?.failed_reason
                                        ? event?.failed_reason
                                        : event?.status}
                                    </TT>
                                  }
                                >
                                  <Img
                                    src={
                                      event?.status === "failed"
                                        ? "/images/table-icon/failed.svg"
                                        : event?.status === "sent"
                                        ? "/images/table-icon/Send.svg"
                                        : event?.status === "read"
                                        ? "/images/table-icon/eye.svg"
                                        : event?.status === "delivered"
                                        ? "/images/table-icon/check.svg"
                                        : event?.status === "invalid"
                                        ? "/images/table-icon/invalid.svg"
                                        : event?.status === "pending"
                                        ? "/images/table-icon/pending.svg"
                                        : event?.status === "cancel"
                                        ? "/images/table-icon/cancel.svg"
                                        : "/images/modal-icon/info-icon.svg"
                                    }
                                    color={"#000"}
                                    alt="info-icon"
                                    className="table-icon"
                                    width={15}
                                    height={15}
                                  />
                                </OverlayTrigger>
                                <div>
                                  {event?.order_number
                                    ? `#${event?.order_number}`
                                    : `#${i + 1 + currentPage * limit?.value}`}
                                </div>
                              </div>
                            </td>
                            {/* <td className="text-capitalize">
                              {event?.failed_reason || "-"}
                            </td> */}
                            <td className="text-capitalize">{event?.name}</td>
                            <td>{event?.mobile_number}</td>
                            {/* <td>
                              {new Date(
                                event?.campaign.created_at
                              ).toLocaleString("en-IN", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                                hour: "2-digit",  
                                minute: "2-digit",
                                hour12: true,
                              })}
                            </td> */}
                            {/* <td>
                              {event?.campaign.scheduler_date
                                ? moment(event?.campaign?.scheduler_date).format(
                                    "DD/MM/YYYY hh:mm A"
                                  )
                                : "-"}
                            </td> */}
                            <td className="text-capitalize">
                              {event?.status !== "pending" ? (
                                <StatusChip
                                  bg="chip-ornage"
                                  title={event.status}
                                  className="text-capitalize"
                                />
                              ) : (
                                <div>-</div>
                              )}
                            </td>

                            {/* <td>{event?.credits}</td> */}
                            <td>
                              {event?.whatsapp_sent
                                ? new Date(
                                    event?.whatsapp_sent * 1000
                                  ).toLocaleString("en-IN", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    second: "2-digit",
                                    hour12: true,
                                  })
                                : "-"}
                            </td>
                            <td>
                              {event?.whatsapp_deliver
                                ? new Date(
                                    event?.whatsapp_deliver * 1000
                                  ).toLocaleString("en-IN", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    second: "2-digit",
                                    hour12: true,
                                  })
                                : "-"}
                            </td>
                            <td>
                              {event?.whatsapp_seen
                                ? new Date(
                                    event?.whatsapp_seen * 1000
                                  ).toLocaleString("en-IN", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    second: "2-digit",
                                    hour12: true,
                                  })
                                : "-"}
                            </td>
                            {/* <td  className="table-svg"> */}

                            {!hideDownloadColumn &&                            
                              event?.campaign?.template_type !== "text" &&  ( 
                                <td>
                                  {/* {
                                    event.status !== "pending" && ()
                                  } */}
                                  <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 250, hide: 250 }}
                                    overlay={
                                      <TT id="button-tooltip">Download PDF</TT>
                                    }
                                  >
                                    <button
                                      onClick={() =>
                                        downloadEachPdf(event)
                                      }
                                      className="download-pdf-btn cursor-pointer"
                                    >
                                      <DownloadIcon
                                        width={20}
                                        height={20}
                                        color="#46D22A"
                                      />
                                    </button>
                                  </OverlayTrigger>
                                </td>
                              
                            )}   

                            {/* </td> */}
                            {!["drafted", "scheduled", "in-process"].includes(campaignDetails?.status) && (
                              <td>
                                <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 250 }}
                                  overlay={<TT id="tooltip-resend">Resend</TT>}
                                >
                                  <Button
                                    variant="link"
                                    onClick={() => handleResendSingleRecipient(event)}
                                    disabled={resendLoadingId === event.id}
                                    className="btn-outline-primary-icon d-flex align-items-center justify-content-center p-1"
                                    style={{
                                      width: "24px",
                                      height: "24px",
                                      minWidth: "unset",
                                    }}
                                  >
                                    <RefreshIcon
                                      width={12}
                                      height={12}
                                      color="#A5596A"
                                      strokeWidth="2"
                                    />
                                  </Button>
                                </OverlayTrigger>
                              </td>
                            )}
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </Table>
              </div>

              <div className="p-3 mx-1 d-flex flex-wrap align-items-center justify-content-between gap-4">
                {typeof total === "number" &&
                  !isNaN(total) &&
                  total > 0 &&
                  campaignDetailListWithoutRedux?.data?.length > 0 && (
                    <p className="custom-table-infotext ">
                      Displaying {currentPage * limit?.value + 1} to{" "}
                      {Math.min((currentPage + 1) * limit?.value, total)} of{" "}
                      {total} Customers
                    </p>
                  )}
                {/* {campaingDetailsData?.data?.length !== 0 && ( */}
                {campaignDetailListWithoutRedux?.data?.length > 0 && (
                  <>
                    <CreatableSelect
                      isClearable
                      options={recordsPerPageOptions}
                      value={limit}
                      onChange={handleChange}
                      placeholder="Select or create"
                      menuPortalTarget={document.body} // Render the menu at the body level
                      menuPlacement="top" // Display the options above the input
                      styles={{
                        control: (base) => ({
                          ...base,
                          width: "170px", // Fixed width for the input field
                        }),
                        menu: (base) => ({
                          ...base,
                          width: "170px", // Fixed width for the dropdown menu
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999, // Ensure it appears above everything
                        }),
                      }}
                    />

                    <CommonPagination
                      totalItems={total}
                      itemsPerPage={limit?.value}
                      currentPage={currentPage + 1}
                      onPageChange={handlePageChange}
                    />
                  </>
                )}
              </div>
            </div>
          </Col>
        </Row>

        <ConfirmationModal
          show={showCreditModal}
          onHide={() => setShowCreditModal(false)}
          onConfirm={downloadMode === "multiple" ? handleConfirmCreditDeductionMultiple : downloadMode === "all" ? handleConfirmDownloadAll : handleConfirmCreditDeduction}
           title={confirmationTitle}
            message={confirmationMessage}
        />



        {/* Hand a stalled campaign to the customer's helpers. */}
        <Modal
          show={showManualModal}
          centered
          dialogClassName="common-popup-dialog common-popup-dialog-size"
          contentClassName="common-popup-content"
          backdropClassName="common-popup-backdrop"
        >
          <Modal.Body className="common-popup-body">
            <div
              className="position-absolute end-0 z-2 bg-white rounded-1 cursor-pointer d-flex align-items-center justify-content-center common-popup-colose-btn"
              onClick={() => setShowManualModal(false)}
            >
              <Cancel01Icon width={16} height={16} color="#BCBBC1" strokeWidth="2.5" />
            </div>

            <div className="text-center common-popup-heading">
              <div className="common-mb-space">
                <div className="d-flex align-items-center justify-content-center">
                  <UserGroup03Icon width={48} height={48} color="#A5596A" strokeWidth="1.5" />
                </div>
                <h4 className="pt-2 mt-1 fw-medium">Hand to helpers?</h4>
                <p className="mt-3">
                  We stop sending this campaign. The guests still waiting move to
                  your helpers' console, and they send from their own phones.
                </p>
              </div>

              <div className="text-start border rounded-2 p-3 mb-3">
                <div className="d-flex justify-content-between mb-2">
                  <span>Already delivered &mdash; left alone</span>
                  <strong>{manualSettlement?.already_sent ?? 0}</strong>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <span>Helpers will send</span>
                  <strong>{manualSettlement?.to_send_manually ?? 0}</strong>
                </div>
                <hr className="my-2" />
                <div className="d-flex justify-content-between mb-2">
                  <span>Credits returned</span>
                  <strong className="text-success">
                    +{manualSettlement?.refund_credits ?? 0}
                  </strong>
                </div>
                <div className="d-flex justify-content-between">
                  <span>
                    Manual sending ({manualSettlement?.manual_rate ?? 0} per guest)
                  </span>
                  <strong className="text-danger">
                    &minus;{manualSettlement?.charge_credits ?? 0}
                  </strong>
                </div>
              </div>

              {/* Says plainly why the two numbers differ, which is otherwise the
                  most confusing part of the settlement. */}
              {manualSettlement &&
                manualSettlement.to_send_manually > manualSettlement.refund_credits && (
                  <p className="text-start text-muted mb-3">
                    {manualSettlement.to_send_manually - manualSettlement.refund_credits}{" "}
                    of these were already refunded when they failed, so they are not
                    refunded again.
                  </p>
                )}

              <p className="mb-3">This cannot be undone.</p>

              <div className="d-flex align-items-center justify-content-center pt-2 gap-3">
                <CommomButton
                  onClick={() => setShowManualModal(false)}
                  title="Cancel"
                  className="btn-muted"
                />
                <CommomButton
                  disabled={isManualBusy}
                  onClick={handleConfirmManualFallback}
                  title={isManualBusy ? "Handing over..." : "Hand over"}
                  className="btn-primary"
                />
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/* To cancel Schedule Campaign */}
        <DeletePopup
          show={openCancelCampaign}
          onHide={() => setOpenCancelCampaign(false)}
          icon={
            <Delete02Icon
              width={48}
              height={48}
              color="#ff4c51"
              strokeWidth="1.5"
            />
          }
          title="Confirm Schedule Cancel?"
          content="Are you sure you want to Draft this campaign?"
          removeTitle="Cancel"
          onClickSave={handleCancelScheduleCampaign}
          saveTitle={isSubmitting ? "Drafting..." : "Draft"}
        />

        {/* Delete Pop up */}
        <DeletePopup
          show={deleteCampaignModal}
          onHide={() => setDeleteCampaignModal(false)}
          icon={
            <Delete02Icon
              width={48}
              height={48}
              color="#ff4c51"
              strokeWidth="1.5"
            />
          }
          title="Confirm Delete?"
          content="Are you sure you want to delete this campaign?"
          removeTitle="Cancel"
          onClickSave={handleConfirmDeleteCampaign}
          disabled={isSubmitting}
          saveTitle={isSubmitting ? "Deleting..." : "Delete"}
        />

        <Modal
          show={showAddModal}
          centered
          dialogClassName="common-popup-dialog"
          contentClassName="common-popup-content"
          backdroscheduledpClassName="common-popup-backdrop"
        >
          <Modal.Body className="common-popup-body">
            <div
              className="position-absolute end-0 z-2 bg-white rounded-1 cursor-pointer d-flex align-items-center justify-content-center  common-popup-colose-btn"
              onClick={handleModalClose}
            >
              <Cancel01Icon
                width={16}
                height={16}
                color="#BCBBC1"
                strokeWidth="2.5"
              />
            </div>
            <div className="mb-4 text-center common-popup-heading">
              <h4 className="text-capitalize mb-2 fw-medium">New Campaign</h4>
              <p>
                Are you sure, you want to make a new copy of {activeTabStatus} ?
              </p>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3 common-popup-btn">
              <CommomButton
                title={loading ? "Adding..." : "Add"}
                type="submit"
                disabled={loading}
                className="btn-primary primary-shadow"
                onClick={handleInvalidClick}
              />
              <CommomButton
                title="Cancel"
                onClick={handleModalClose}
                className="btn-muted"
                disabled={loading}
              />
            </div>
          </Modal.Body>
        </Modal>
        {/* <PdfZoomViewModal
          show={openPdfModalView}
          handleClose={handleClosePdfViewModal}
          pdfPageWiseView={pdfPageWiseView}
          campaingDetails={campaingDetails}
        /> */}

        {/* {console.log("pdfPageWiseView :::", pdfPageWiseView)} */}

        <div className="pdf-viewer-custom h-107">
          {/* This package for zooming pdf not working in some pdf */}
          {/* <ReactImageCarouselViewer
            open={isOpen}
            onClose={() => setIsOpen(false)}
            images={pdfPageWiseView.length ? pdfPageWiseView : [{ src: "" }]}
            startIndex={index}
          /> */}
          {/* Add Image Gallery Viewer */}
          <PdfViewer
            pdfPageWiseView={pdfPageWiseView}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />
        </div>
      </Container>
    </CommonLayout>
  );
}
